import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { PatientMoveDialogComponent } from "./patient-move-dialog/patient-move-dialog.component";
import { DashboardService } from "./dashboard.service";
import { DashboardModel } from "./Models/dashboard.model";
import { AuthService } from "app/auth/auth.service";
import { LocationSubFilterModel } from "./Models/locationsubfilter.model";
import { DatePipe } from "@angular/common";
import { FinishDilationComponent } from "./finish-dilation/finish-dilation.component";
import { RemoveDilationComponent } from "./remove-dilation/remove-dilation.component";
import { RemarksComponent } from "./remarks/remarks.component";
import { DialationStartsComponent } from "./dialation-starts/dialation-starts.component";
import { SiteloaderComponent } from "app/auth/siteloader/siteloader.component";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Patient_trackingComponent } from "app/table-list/patient_tracking/patient_tracking.component";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { EMRService } from "app/EMR/EMR.service";
import { PatientdocsComponent } from "app/table-list/patientdocs/patientdocs.component";
import { ChangecategoriesComponent } from "./changecategories/changecategories.component";
import { ChangeremarkComponent } from "./changeremark/changeremark.component";
import { WaitingReasonComponent } from "./WaitingReason/WaitingReason.component";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "app/shared/language.service";
import { BehaviorSubject, forkJoin, Observable, of, Subject, Subscription } from "rxjs";
import { Message } from "_debugger";
import { FormControl } from "@angular/forms";
import { startWith } from "rxjs/operators/startWith";
import { map } from "rxjs/operators/map";
import { Sort } from '@angular/material/sort';
import {
  CdkDragDrop,
  CdkDragEnd,
  CdkDragEnter,
  CdkDragExit,
  CdkDragStart,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import * as moment from "moment";
import {
  GuidedTourService,
  Orientation,
  GuidedTour,
  ProgressIndicatorLocation,
} from "ngx-guided-tour";
import { BillingComponent } from "app/billing/billing.component";
import { switchMap, takeUntil } from "rxjs/operators";
import { SearchDialogComponent } from "app/table-list/Searchdialog/SearchDialoag.component";
import { ChartType, ChartOptions, ChartDataSets } from "chart.js";
import { Label, Color } from "ng2-charts";
import { OptoModel } from "app/EMR/PrimaryExaminationModels/opto.model";
import { IPDService } from "app/ipd/Services/ipdServices.service";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { CounselorComponent } from "app/EMR/Counselor/Counselor.component";
import { UpgradeComponent } from "app/upgrade/upgrade.component";
import { VoiceRecognitionService } from "app/masters/service/voice-recognition.service";
import { AppointmentColorModel } from "app/opdvisits/Models/appointment_color.model";
import { AIPrescriptionComponent } from "app/EMR/Doctor/aiprescription/aiprescription.component";


@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  // encapsulation: ViewEncapsulation.None,

  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", display: "none" })
      ),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class DashboardComponent implements OnInit {
  @ViewChild("closebutton") closebutton;
  destroydashboard$: Subject<boolean> = new Subject<boolean>();
  private clinicAreaSubject = new BehaviorSubject<any[]>([]); // Holds the current state of options
  private showgrid = false;
  private searchstring;
  private usertypeid: number;
  private userid: number;
  private checkfilteravlue: number = 0;
  private sortcounter: number = 0;
  private SelectedPatientObj: any = {};
  private filterTerm: string;
  private locationcount: LocationSubFilterModel[] = [];
  //public modeselect = "ALL";
  private selectReportValue: string = "Prescription";
  private masterdata = {};
  private selectedcategory = 0;
  private selectedusername: any;
  locationname: any;
  private selectedRowIndex = -1;
  private showspinner: boolean = false;
  private selectedLanguage: any; // language varible
  private opd_visits: DashboardModel[] = [];
  private usertype_opd_visits: DashboardModel[] = []; // filter master based on usertype
  private location_opd_visits: DashboardModel[] = []; // filter based on location
  private categories_location_opd_visits: DashboardModel[] = []; // filter based on categories for specific location
  private time_usertype_visits: DashboardModel[] = []; // filter based time selection (will filter usertype list)
  private user_filter: DashboardModel[] = []; // filter based on user id selection once location filter is initiated
  private locationsubfilterlist: LocationSubFilterModel[] = []; // it initiates the  user id dropdown
  private megyek: Observable<any[]>;
  private colora: any;
  private colorb: any;
  private colorc: any;
  private expandedElement: DashboardModel | null;
  private q: number;
  private checkSearchType: number;
  private hiddenhtmlview: boolean = true;
  private childEvent: boolean = true;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('categoryInput') categoryInput: ElementRef;
  // @ViewChild(MatSort, { static: false }) matSort: MatSort;
  private signalRSubscription: Subscription;

  private lastlocation: number;
  private content: Message;
  private dataSource = new MatTableDataSource<DashboardModel>();
  private ColomsArry: any = [];
  private SelectedColoums: any = [];
  private ShowAreaName: any;
  private areaArray: any = [];
  private ClinicalAreaArray: any = [];
  public ShowUserName: any;
  private CatCtrl: FormControl;
  private userFielCtrl: FormControl;
  private filteredCatArray: Observable<any[]>;
  private filteredUserArray: Observable<any[]>;
  private AreaCtrl: FormControl;
  private ClinicAreaCtrl: FormControl;
  private filteredAreaArray: Observable<any[]>;
  private filteredClinicAreaArray: Observable<any[]> = this.clinicAreaSubject.asObservable();
  private userCtrl: FormControl;
  private FreshCount: number;
  private reviewCount: number;
  private dilatedCount: number;
  private currentDateAndtime: any;
  private receptionList: DashboardModel[] = [];
  private autoRefList: DashboardModel[];
  private locationName: string;
  private clinicaldeptList: DashboardModel[];
  private receptions: boolean = false;
  private autoRefs: string;
  private doctorl: DashboardModel[];
  private Optometrist: DashboardModel[];
  private physicianList: DashboardModel[];
  private dilationTittle: string;
  private languagetranlate: any = {};
  private progressIndicatorLocation = ProgressIndicatorLocation.TopOfTourBlock;
  private readonly ETOUR: GuidedTour = {
    tourId: "GuideTour",
    useOrb: false,

    steps: [
      {
        // title: 'Table Setting',
        selector: "#left-btn",
        content:
          "<div class='shape shape-12'><img src='../../assets/img/tour-arrow-shape/sidenavgp.svg'/></div><div class='tour-box'><div class='tour-title'>Side Menu</div><div class='txt'>Click here to expand / collapse the left panel</div></div>",
        orientation: Orientation.Bottom,
      },
      {
        // title: 'Table Setting',
        selector: "#cog",
        content:
          "<div class='shape shape-1'><img src='../../assets/img/tour-arrow-shape/tablesettinggp.svg'/></div><div class='tour-box'><div class='tour-title'>Table Setting</div><div class='txt'>Click here to add / remove columns in OPD dashboard</div></div>",
        orientation: Orientation.Bottom,
      },
      {
        // title: 'Step in paragraph',
        content:
          "<div class='shape shape-2'><img src='../../assets/img/tour-arrow-shape/categorygp.svg'/></div><div class='tour-box'><div class='tour-title'>Category Filter</div><div class='txt'>Click here to filter patients as per category</div></div>",
        selector: "#categoryNameSearchBox",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#chipList",
        content:
          "<div class='shape shape-3'><img src='../../assets/img/tour-arrow-shape/patientlocationgp.svg'/></div><div class='tour-box'><div class='tour-title'>Patient locations</div><div class='txt'>Click here to filter patients as per patient location</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#login-user",
        content:
          "<div class='shape shape-11'><img src='../../assets/img/tour-arrow-shape/userdetailgp.svg'/></div><div class='tour-box'><div class='tour-title'>User details</div><div class='txt'>Click here to view / change login details, change password or logout</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#chipListSelectAll",
        content:
          "<div class='shape shape-4'><img src='../../assets/img/tour-arrow-shape/allgp.svg'/></div><div class='tour-box'><div class='tour-title'>All</div><div class='txt'>Click here to view all patients</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#UHID",
        content:
          "<div class='shape shape-5'><img src='../../assets/img/tour-arrow-shape/uhidgp.svg'/></div><div class='tour-box'><div class='tour-title'>UHID</div><div class='txt'>Click in patient row to open OPD EMR</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#patientName",
        content:
          "<div class='shape shape-6'><img src='../../assets/img/tour-arrow-shape/patientnamegp.svg'/></div><div class='tour-box'><div class='tour-title'>Patient Name</div><div class='txt'>Click in patient row to see tracking, summary and other patient details</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#categoryName",
        content:
          "<div class='shape shape-7'><img src='../../assets/img/tour-arrow-shape/categorynamegp.svg'/></div><div class='tour-box'><div class='tour-title'>Category Name</div><div class='txt'>Click in patient row to change category</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#dilationTime",
        content:
          "<div class='shape shape-8'><img src='../../assets/img/tour-arrow-shape/dilationtimegp.svg'/></div><div class='tour-box'><div class='tour-title'>Dilation Time</div><div class='txt'>Click in patient row to start / end dilation</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#moveTo",
        content:
          "<div class='shape shape-9'><img src='../../assets/img/tour-arrow-shape/movetogp.svg'/></div><div class='tour-box'><div class='tour-title'>Move To</div><div class='txt'>Click the icon in patient row to move the patient to another location</div></div>",
        orientation: Orientation.BottomLeft,
      },
      {
        // title: 'Step in button',
        selector: "#remarks",
        content:
          "<div class='shape shape-10'><img src='../../assets/img/tour-arrow-shape/remarksgp.svg'/></div><div class='tour-box'><div class='tour-title'>Remarks</div><div class='txt'>Click the colored bar in patient row to add / update remarks</div></div>",
        orientation: Orientation.BottomLeft,
      },
    ],
  };
  draggedItemIndex: any;
  patdetails: any;
  usertypeIdmove: number;
  cds: any;
  ars: any;
  ops: any;
  allDoc: any;
  allCss: any;
  allPrs: any;
  pyslist: any;
  today: number;
  userLocTypeid: string;
  locationId: any;
  doughnutChartType: ChartType = "doughnut";
  doughnutChartData: ChartDataSets[] = [
    {
      label: "Dataset A",

      data: [],
    },
    {
      label: "Dataset b",

      data: [],
    },
    {
      label: "Dataset c",

      data: [],
    },
  ];

  doughnutChartOption1: ChartOptions = {
    legend: {
      display: false,
    },
  };

  public doughnutRightData: ChartDataSets[] = [
    { data: [], backgroundColor: ["#005fff", "#31e9e4"], fill: false },
  ];
  public doughnutChartColors: Color[] = [
    {
      backgroundColor: ["#005fff", "#31e9e4"],
    },
  ];
  public doughnutChartColors1: Color[] = [
    {
      backgroundColor: ["#62ab45", "#000", "#000", "#000"],
    },
    {
      backgroundColor: ["#000", "#000", "#000", "#000"],
    },
    {
      backgroundColor: ["#000", "#ffb52c", "#ff7811", "#f83d3e"],
    },
  ];

  public doughnutApptLabels: Label[] = [
    "Appt.Booked",
    "Reported",
    "Not Reported",
    "Cancelled",
  ];

  borderWidth: [0];
  public doughnutChartLabels: Label[] = ["Fresh Patient", "Review Patient"];

  doughnutChartOption: ChartOptions = {
    legend: {
      display: false,
    },

    // pieceLabel: {
    //   render: function (args) {
    //     const label = args.label,
    //       value = args.value;
    //     return value + "%";
    //   },
    //   fontStyle: 'bold',

    // }
  };

  constructor(
    private dialog: MatDialog,
    private dashboardService: DashboardService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private opdvisitService: OpdVisitService,
    private http: HttpClient,
    private title: Title,
    private route: Router,
    private translate: TranslateService,
    private langservice: LanguageService,
    private emrservice: EMRService,
    private guidedTourService: GuidedTourService,
    private ipdService: IPDService,
    private branchMatserService: BranchMatserService,
    private speachtotextservice: VoiceRecognitionService
  ) {
    this.getcoloumlistbyuserid();
    this.gettime_slots();
    // this.dashboardService.getcolumnwidthandcaption();
    if (this.authService.DynamicLinks?.requiredSignal == 'Y' || this.authService.DynamicLinks?.requiredSignal == 'y') {
      this.authService.connect();
      this.signalRSubscription = this.authService
        .getMessage()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe((message) => {
          this.content = message;
          this.get_opd_visits();
        });
    }

    this.dashboardService.getlocations();
    translate.addLangs(["en", "fr", "hi"]);

    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    } else {
      translate.setDefaultLang("en");
    }
    this.getchangedlanguage();
    this.speachtotextservice.init();
  }
  getchangedlanguage() {
    this.translate
      .get([
        "dashboardValidMsg.msg1",
        "Ok",
        "dashboardValidMsg.msg2",
        "dashboardValidMsg.msg3",
        "dashboardValidMsg.msg4",
        "dashboardValidMsg.msg5",
        "dashboardValidMsg.msg6",
        "dashboardValidMsg.msg7",
        "dashboardValidMsg.msg8",
        "dashboardValidMsg.msg9",
        "dashboardValidMsg.msg10",
        "dashboardValidMsg.msg11",
        "dashboardValidMsg.msg12",
        "dashboardValidMsg.msg13",
        "dashboardValidMsg.msg14",
        "dashboardValidMsg.msg15",
        "dashboardValidMsg.msg16",
        "dashboardValidMsg.msg17",
        "dashboardValidMsg.msg18",
        "dashboardValidMsg.msg19",
        "dashboardValidMsg.msg20",
        "dashboardValidMsg.msg21",
        "dashboardValidMsg.msg22",
        "dashboardValidMsg.msg23",
        "dashboardValidMsg.msg24",
        "dashboardValidMsg.msg25",
        "dashboardValidMsg.msg26",
        "dashboardValidMsg.msg27",
        "dashboardValidMsg.msg28",
        "dashboardValidMsg.msg29",
        "dashboardValidMsg.msg30",
        "dashboardValidMsg.msg31",
        "dashboardValidMsg.msg32",
        "dashboardValidMsg.msg33",
        "dashboardValidMsg.msg34",
        "dashboardValidMsg.msg35",
        "dashboardValidMsg.msg36",
        "dashboardValidMsg.msg37",
        "dashboardValidMsg.msg38",
        "dashboardValidMsg.msg39",
        "dashboardValidMsg.msg40",
        "dashboardValidMsg.msg41",
        "dashboardValidMsg.msg42",
        "dashboardValidMsg.msg43",
        "dashboardValidMsg.msg44",
        "dashboardValidMsg.msg45",
        "dashboardValidMsg.msg46",
        "dashboardValidMsg.msg47",
        "dashboardValidMsg.msg48",
        "dashboardValidMsg.msg49",
        "dashboardValidMsg.msg50",
        "dashboardValidMsg.msg51",
        "dashboardValidMsg.msg52",
        "dcontent1",
        "dcontent2",
        "dcontent3",
        "dcontent4",
        "dcontent5",
        "dcontent6",
        "dcontent7",
        "dcontent8",
        "dcontent9",
        "dcontent10",
        "dcontent11",
        "dcontent12",
      ])
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((x) => {
        this.languagetranlate = [];

        this.authService.validationMsg = {};
        this.authService.validationMsg = x;
        this.languagetranlate = [
          {
            selector: "#left-btn",
            content: x["dcontent1"],
            orientation: Orientation.Bottom,
          },
          {
            // title: 'Table Setting',
            selector: "#cog",
            content: x["dcontent2"],
            orientation: Orientation.Bottom,
          },
          {
            // title: 'Step in paragraph',
            content: x["dcontent3"],
            selector: "#categoryNameSearchBox",
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#chipList",
            content: x["dcontent4"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#login-user",
            content: x["dcontent5"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#chipListSelectAll",
            content: x["dcontent6"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#UHID",
            content: x["dcontent7"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#patientName",
            content: x["dcontent8"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#categoryName",
            content: x["dcontent9"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#dilationTime",
            content: x["dcontent10"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#moveTo",
            content: x["dcontent11"],
            orientation: Orientation.BottomLeft,
          },
          {
            // title: 'Step in button',
            selector: "#remarks",
            content: x["dcontent12"],
            orientation: Orientation.BottomLeft,
          },
        ];
      });
  }

  // ngAfterViewInit(){
  //   if (this.authService.Loggeduser.usertypeid == 6 || this.authService.Loggeduser.usertypeid ==5) {

  //     this.selectedusername = this.authService.Loggeduser.firstname;
  //     setTimeout(()=>{
  //       this.userCtrl.setValue(this.selectedusername);
  //     },500)

  //   } else {
  //     this.selectedusername = "ALL";
  //   }
  // }

  tablesetting() {
    document.getElementById("TableSettingModel").style.display = "block";
    //
  }
  tablesettingclose() {
    document.getElementById("TableSettingModel").style.display = "none";
    //
  }
  // addcolomstoArray(col:any){
  //   this.ColomsArry.push(col);
  //  }

  categoryControll() {
    if (this.dashboardService.ShowCateName) {
      this.CatCtrl = new FormControl(this.dashboardService.ShowCateName);
    } else {
      this.CatCtrl = new FormControl('');
    }

    this.filteredCatArray = this.CatCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filtercategoryfunction(cat)
          : this.dashboardService.categories.slice()
      )
    );
  }

  filtercategoryfunction(name: string) {
    var temp = name.toString().toLowerCase();
    return this.dashboardService.categories.filter(
      (cat) => cat.categoryName.toLowerCase().indexOf(temp) === 0
    );
  }

  Checkcategorydata(event: any) {
    var checkdata = event.target.value;
    if (!checkdata) {
      this.dashboardService.ShowCateName = null;
      // this.categoryControll();
      this.authService.storevisitdata.subscribe(res => {
        this.successopdvisit(res);
      })

    }
  }

  checkSelecedcol(Id, event, col, i) {
    const checked = event.target.checked;
    if (checked) {
      this.ColomsArry.splice(i, 0, col);
      col.isShow = true;
      if (this.ColomsArry.length > 0) {
        this.ColomsArry = this.ColomsArry.sort((a, b) => a.seqNo - b.seqNo);
      }
      this.authService
        .setselectedColoums(col)
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe((data) => { }); // push the Id in array if checked
    } else {
      col.isShow = false;
      const index = this.ColomsArry.findIndex((list) => list.pkTranId == Id); //Find the index of stored id
      this.ColomsArry.splice(index, 1);
      if (this.ColomsArry.length > 0) {
        this.ColomsArry = this.ColomsArry.sort((a, b) => a.seqNo - b.seqNo);
      }
      this.authService
        .setselectedColoums(col)
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe((data) => { });
    }
  }

  ngAfterViewChecked() {
    this.authService.checksingalR = true;

  }
  ngOnDestroy(): void {
    console.log("destroy dashboard");
    this.destroydashboard$.next(true);
    this.destroydashboard$.unsubscribe();
    if (this.authService.DynamicLinks?.requiredSignal == 'Y' || this.authService.DynamicLinks?.requiredSignal == 'y') {
      this.authService.disconnect();
      this.signalRSubscription.unsubscribe();
      this.authService.getcopySubscription.unsubscribe();
    }
    this.opd_visits = null;
    this.childEvent = null;
    this.dashboardService.categoryupdated = null;
    this.usertype_opd_visits = null;
    this.location_opd_visits = null;
    this.categories_location_opd_visits = null;
    this.time_usertype_visits = null;
    this.user_filter = null;
    this.locationsubfilterlist = null;
    this.locationcount = null;
    this.checkSearchType = null;
    this.ColomsArry = null;
    this.SelectedColoums = null;
    this.dashboardService.widthandcaption = null;
    this.receptionList = null;
    this.autoRefList = null;
    this.locationName = null;
    this.clinicaldeptList = null;
    this.autoRefs = null;
    this.doctorl = null;
    this.Optometrist = null;
    this.physicianList = null;
    this.dilationTittle = null;
    this.languagetranlate = null;
    this.doughnutRightData = null;
    this.doughnutChartData = null;
    this.dashboardService.maxAgeColorCode = null;
    this.dashboardService.minAgeColorCode = null;
    this.showgrid = null;
    this.searchstring = null;
    this.checkfilteravlue = null;
    this.sortcounter = null;
    this.SelectedPatientObj = null;
    this.filterTerm = null;
    this.locationcount = null;
    this.selectReportValue = null;
    this.masterdata = null;
    this.selectedcategory = null;
    this.selectedusername = null;
    this.selectedRowIndex = null;
    this.showspinner = null;
    this.selectedLanguage = null;
    this.opd_visits = null;
    this.usertype_opd_visits = null;
    this.location_opd_visits = null;
    this.categories_location_opd_visits = null;
    this.time_usertype_visits = null;
    this.user_filter = null;
    this.locationsubfilterlist = null;
    this.megyek = null;
    this.colora = null;
    this.colorb = null;
    this.colorc = null;
    this.q = null;
    this.checkSearchType = null;
    this.lastlocation = null;
    this.dataSource = null;
    this.ColomsArry = null;
    this.SelectedColoums = null;
    this.ShowAreaName = null;
    this.areaArray = null;
    this.ClinicalAreaArray = null;
    //this.dashboardService.ShowCateName = null;
    this.ShowUserName = null;
    this.CatCtrl = null;
    this.userFielCtrl = null;
    this.filteredCatArray = null;
    this.filteredUserArray = null;
    this.AreaCtrl = null;
    this.ClinicAreaCtrl = null;
    this.filteredAreaArray = null;
    this.filteredClinicAreaArray = null;
    this.userCtrl = null;
    this.FreshCount = null;
    this.reviewCount = null;
    this.dilatedCount = null;
    this.currentDateAndtime = null;
    this.receptionList = null;
    this.autoRefList = null;
    this.locationName = null;
    this.clinicaldeptList = null;
    this.receptions = null;
    // this.selecteduser = null;
    this.progressIndicatorLocation = ProgressIndicatorLocation.TopOfTourBlock;
    this.ETOUR.steps = null;
    this.hiddenhtmlview = null;
  }
  switchLang(lang: string) {
    this.selectedLanguage = lang;
    //console.log('selectedLanguage',this.selectedLanguage)
    this.langservice.switchLang(lang);
    this.getchangedlanguage();
  }
  gotoappointment() {
    this.route.navigate(["/layout/Appointments"], { replaceUrl: true });
  }


  checkvalue(value: string) {
    //console.log ("Email not found " + eid);
    if (value == "" || value == null) {
      return "Not Provided";
    } else {
      return value;
      //this.formatreturntime(value);
    }
  }

  checkboolean(value: boolean) {
    if (value == false) {
      return "No";
    } else {
      return "Yes";
    }
  }
  closeCallPatientModel() {
    document.getElementById("callPatientpendingModel").style.display = "None";
  }
  gotoemr(
    patientid: number,
    docId: any,
    passage: any,
    gender: any,
    visitid: any,
    isDilated: any,
    locId: any,
    ispd,
    partyName: any,
    referedbyName: any,
    pName: any
  ) {

    this.opdvisitService.partymaster_name = null;
    this.opdvisitService.refferedby_name = null;
    this.emrservice.visitid = null;
    this.dashboardService.ispd = ispd;
    this.dashboardService.docterEmr.isDilated = isDilated;
    this.dashboardService.docterEmr.locationId = locId;
    this.dashboardService.docterEmr.fK_RegID = patientid;
    this.opdvisitService.printpriciptionAge = passage + "/" + gender;
    this.opdvisitService.DoctorIdEmr = docId;
    this.opdvisitService.visitid = visitid;
    this.emrservice.visitid = visitid;
    this.opdvisitService.partymaster_name = partyName;
    this.opdvisitService.refferedby_name = referedbyName;
    this.authService.showspinner = true;
    this.opdvisitService.patientdetails.pkRegId = patientid;

    // 
    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
    var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
    var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
    if (queueproty[0]?.propertyValue == 'Y' && queueurl[0]?.propertyValue != null && queueurl[0]?.propertyValue != undefined && queuetoken[0]?.propertyValue != null && queuetoken[0]?.propertyValue != undefined) {
      this.dashboardService.patientname = pName;
      this.callpatientstatus(patientid, this.datePipe.transform(
        this.dashboardService.todaysdate,
        "yyyy-MM-dd"
      ), queueurl[0]?.propertyValue, queuetoken[0]?.propertyValue)
      this.opdvisitService.get_old_photo();
    } else {
      this.getpatientdetails(patientid, "emr");
    }

  }
  callstausModelobj: any = {};
  callpatientstatus(regid: any, visitdate: any, queurl: any, token: any) {
 
    const headers = new HttpHeaders().set('X-API-KEY', `${token}`);
    this.http
      .get<any>(
        queurl +
        "Interface/GetVisitcalldetails/" +
        regid +
        "/" +
        visitdate + '/' + this.authService.Loggeduser.branchid,
        { headers }
      )
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((resp) => {

        this.callstausModelobj = resp;
        if (this.callstausModelobj?.fK_VisitId != null) {
          document.getElementById("callPatientpendingModel").style.display = "block";
        } else {
          this.getpatientdetails(this.dashboardService.docterEmr.fK_RegID, "emr");
        }

      });

  }
  closedata() {
    this.getpatientdetails(this.dashboardService.docterEmr.fK_RegID, "emr");
    this.closeCallPatientModel();
  }
  changeremark(visitid: number, remark: string) {
    const dialogRef = this.dialog.open(ChangeremarkComponent, {
      panelClass: "full-width-dialog",
      // height: '40%',
      width: "40%",
      data: {
        remark: remark,
        visitid: visitid,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        if (this.dashboardService.remarkupdated == true) {
          this.refresh_opd_visits();
          this.dialog.closeAll();
        }
        this.dashboardService.remarkupdated = null;
      });
  }

  changecategory(
    visitid: number,
    catid: number,
    patID: string,
    patientName: string
  ) {
    const dialogRef = this.dialog.open(ChangecategoriesComponent, {
      disableClose: true,
      panelClass: "full-width-dialog",
      // height: '30%',
      width: "35%",
      data: {
        categoryid: catid,
        visitid: visitid,
        patID: patID,
        patientName: patientName,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        if (this.dashboardService.categoryupdated == true) {
          this.refresh_opd_visits();
        }
        this.dashboardService.categoryupdated = null;
        this.dialog.closeAll();
      });
  }
  clearPdata(event) {
    if (event == null || event == "") {
      this.clearPatientInfo();
      this.childEvent = true;
    }
  }
  serachuhid: number = null;
  getpatient(pid, type) {
    if (pid != null && pid != "") {
      this.getpatientdetails(pid, type);
      if (type == 'withoutvisit') {
        this.childEvent = false;
      }
    } else {
      this.clearPatientInfo();
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg1"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  clearPatientInfo() {
    this.serachuhid = null;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.visitdates = [];
    this.opdvisitService.url = "";
    this.emrservice.visitid = null;
    this.opdvisitService.printpriciptionAge = null;
    this.emrservice.billingAmount = null;
    this.emrservice.paidAmount = null;
    this.emrservice.reportingTime = null;
    this.emrservice.returnTime = null;
    this.emrservice.visitType = null;
    this.emrservice.billStatus = null;
  }
  opensearchDialog(type): void {
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "90%",
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        if (type == 1) {
          if (result > 0) {
            // this.clearPatientInfo();
            let flag = "withoutvisit";
            this.get_visit_dates(
              this.opdvisitService.patientdetails.pkRegId,
              flag
            );
          } else {
          }
          this.serachuhid = this.opdvisitService?.patientdetails?.pkRegId;
        }
      });
  }

  getpartyName(partyid: number) {
    if (partyid > 0) {
      return this.opdvisitService.partymaster.filter(
        (item) => item.pkPartyId == partyid
      )[0]?.partyName;
    } else {
      return "";
    }
  }
  getpatientdetails(patientid: number, type) {
    this.open_loader_Dialog();
    this.dashboardService
      .getPateintDEtails(patientid)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => this.successpatient_details(data, type),
        (err) => this.failedpatient_details(err)
      );
  }

  successpatient_details(data, type) {
    // //console.log(data)
    if (data.pkRegId > 0) {
      if (type == "emr") {
        this.opdvisitService.patientdetails = data;
        this.emrservice.empty_list_arrays();
        this.bindemrdata();
      } else {
        this.opdvisitService.patientdetails = data;
        let flag = "withoutvisit";
        this.get_visit_dates(this.opdvisitService.patientdetails.pkRegId, flag);
        this.opdvisitService.get_old_photo();
      }
      if (data.dob != null) {
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(
          data.dob,
          "yyyy-MM-dd"
        );
        this.opdvisitService.getages(data.dob);
      } else {
        var tdate = new Date(data.regDate);
        this.opdvisitService.patientdetails.ageYear =
          this.opdvisitService.patientdetails.ageYear != null
            ? this.opdvisitService.patientdetails.ageYear
            : 0;
        this.opdvisitService.patientdetails.ageMonth =
          this.opdvisitService.patientdetails.ageMonth != null
            ? this.opdvisitService.patientdetails.ageMonth
            : 0;
        this.opdvisitService.patientdetails.ageDays =
          this.opdvisitService.patientdetails.ageDays != null
            ? this.opdvisitService.patientdetails.ageDays
            : 0;
        tdate.setDate(
          tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays
        );
        tdate.setMonth(
          tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth
        );
        tdate.setFullYear(
          tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear
        );
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(
          tdate,
          "yyyy-MM-dd"
        );
        this.opdvisitService.getDataDiffs(
          new Date(this.opdvisitService.patientdetails.dob),
          new Date(
            this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd")
          )
        );
      }
    } else {
      this.dashboardService.openSnackBar("This Patient Not Registered", "Ok");
    }
  }

  failedpatient_details(err) {
    this.dialog.closeAll();
  }

  ngOnInit() {
   this.opdvisitService.patientdetails={};
    this.dashboardService.reportTitle = "";
    this.hiddenhtmlview = true;

    // this.customSearchFillter();

    //  this.ColomsArry = this.dashboardService.widthandcaption;
    //  console.log('col',this.ColomsArry)
    this.dashboardService.widthandcaption = [];

    this.opdvisitService.url = "";
    this.lastlocation = null;
    // this.get_opd_visits();
    this.opdvisitService.get_patient_docurl();
    this.selectedRowIndex = -1;
    this.title.setTitle("WebNetram-Dashboard");
    this.currentDateAndtime = this.authService.localDate;

    this.dataSource.data = null;
    this.dashboardService.captions = [];
    this.usertypeid = this.authService.Loggeduser.usertypeid;
    this.dashboardService.getcategories();
    // this.getappointment_details();
    this.userCtrl = new FormControl();
    this.ClinicAreaCtrl = new FormControl();
    this.getname_pattern();
    this.GetAreaClinicalData();
    // this.filterby_todays_date(this.checkfilteravlue);
    if (this.authService.checkfirsttimeload == false) {
      this.dashboardService.todaysdate = this.authService.getServerDate;
      this.dashboardService.selecteddate = this.datePipe.transform(
        this.dashboardService.todaysdate,
        "yyyy-MM-dd"
      );
      this.opdvisitService.callsepecificApi = "ALL";
      this.dashboardService.selecteduser = "ALL";
      this.dashboardService.ShowCateName = null;
      this.dashboardService.ShowClinicAreaName = null;
      this.filterby_todays_date(this.checkfilteravlue);

    } else {

      // this.getcopyapidata();
      this.selectedusername = this.dashboardService.selecteduser;
      this.filterby_todays_date(0);
      // this.authService.storevisitdata.subscribe(item => {
      //   this.successopdvisit(item);
      // })

    }

    this.getuserlist_default();
    this.SelectedPatientObj = {};

    this.categoryControll();


    // this.GetAreaData();
    // this.AreaControll();
    // this.gettime_slots();
    // if(this.authService.tourGuideDashboard ==false){
    //   setTimeout(()=>{
    //     this.guidedTourService.startTour(this.ETOUR);
    //    },500);
    // }

    this.opdvisitService.share
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((x: any) => {
        if (x == 2) {
          this.ETOUR.steps = [];
          this.ETOUR.steps = this.ETOUR.steps.concat(this.languagetranlate);
          this.guidedTourService.startTour(this.ETOUR);
        }
      });
    // this.liveTimer();
    this.getBranchDetail(this.authService.Loggeduser.branchid);

    this.dashboardService.moudletype
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((quote) => {
        if (quote == 1) {
          this.dashboardService.getlocations();
          this.dashboardService.getcategories();
          this.getcoloumlistbyuserid();
          this.getuserlist_default();
          this.get_opd_visits();
        }
      });

  }

  // public DashboardstartTour(): void {
  //   this.guidedTourService.startTour(this.ETOUR);
  // }

  getcoloumlistbyuserid() {
    this.authService
      .getcolumnwidthandcaption()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.SelectedColoums = [];
        this.ColomsArry = [];
        this.dashboardService.captions = [];
        data.forEach((element) => {
          if (element.isShowOnDashBoard) {
            this.SelectedColoums.push(element);
          }
          if (element.isShow == true) {
            this.ColomsArry.push(element);
          }
        });

        this.dashboardService.widthandcaption = data;
        for (let item of this.dashboardService.widthandcaption) {
          if (
            item.width != 0 &&
            item.rowNo == 1 &&
            item.fieldCaption != "VIP"
          ) {
            this.dashboardService.captions.push(item.fieldCaption);
            if (item.fieldCaption == "sequence") {
              this.dashboardService.captions.push("F/R");
            }
            if (item.fieldCaption == "TotalTime") {
              this.dashboardService.captions.push("moveto");
            }
            this.dashboardService.setwidth(item);
          }
        }

        this.dashboardService.columnsToDisplay =
          this.dashboardService.captions.slice();

        // console.log(this.ColomsArry)
      });
    // this.ColomsArry = this.dashboardService.widthandcaption;
  }

  colorfun(colotype: any) {
    let colorcode = colotype;
    if (colorcode == "ff") {
      colorcode = "ff0000";
    }
    return "#" + colorcode;
  }
  onMatSortChange() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // get_old_photo(patientid: any) {

  //   this.dashboardService
  //     .getoldphoto(patientid)
  //     .pipe(takeUntil(this.destroydashboard$))
  //     .subscribe(
  //       (data: any) => {
  //         if (data.length > 0) {
  //           this.opdvisitService.url =
  //             data[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
  //         } else {
  //           this.opdvisitService.url =
  //             "./assets/img/noimage.png" +
  //             "?" +
  //             Math.floor(Math.random() * 100) +
  //             1;
  //         }
  //       },
  //       (err) => { }
  //     );
  // }



  get_opd_visits() {
    // this.open_loader_Dialog();

    this.dashboardService
      .getopdvisit()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => this.successopdvisit(data),
        (err) => this.failedopdvisit(err)
      );
  }

  get_visit_dates(patientid: number, flag: string) {
    if (this.authService.masterdata.emrLevel == 3) {
      this.dashboardService
        .getVisitdata(
          patientid,
          this.opdvisitService.visitid,
          this.opdvisitService.DoctorIdEmr
        )
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_visitlist(data, patientid, flag),
          (err) => this.failed_visitlist(err)
        );
    } else {
      this.dashboardService.getVisitdata(patientid, 0, 0).subscribe(
        (data) => this.success_visitlist(data, patientid, flag),
        (err) => this.failed_visitlist(err)
      );
    }
  }

  opendocdialog(patientid: number, patientName: string): void {

    this.opdvisitService.patientdetails.pkRegId = patientid;
    // call dialogue
    const dialogRef = this.dialog.open(PatientdocsComponent, {
      panelClass: "full-width-dialog",
      //  maxWidth: "100vw !important",
      // height: "80%",
      width: "60%",
      data: {
        patID: patientid,
        patientName: patientName,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        //console.log("The dialog was closed");
        //this.animal = result;
        this.get_opd_visits();
      });
  }

  // getsummary_url(patientid: number) {
  //   this.dashboardService.getsummary_url().subscribe(
  //     data => this.succesurl(data, patientid), err => this.failedurl(err)
  //   )
  // }

  // succesurl(data, patientid) {

  //   const urldate = data.filter(item => item.propertyName == 'WebURL');
  //   const url = urldate[0].propertyValue;

  //   var newWindow = window.open(url + 'PatientEMRSummary.aspx?RegID=' + patientid + '&BillCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&VisitOrderType=DESC' + '&BranchId=' + this.authService.Loggeduser.branchid);

  // }

  failedurl(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg8"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  // open_summary(patientid: number) {

  //   this.getsummary_url(patientid);

  // }
  success_visitlist(data, patid: number, flag: string) {
    this.opdvisitService.visitdates = [];
    // this.opdvisitService.visitdates = data;
    this.opdvisitService.visitdates = data.sort((a, b) => {
      return (
        <any>new Date(b.visitDate) - <any>new Date(a.visitDate) ||
        <any>b.pK_ExamId - <any>a.pK_ExamId
      );
    });

    //this.dialog.closeAll();
    if (flag == "tracking") {
      const dialogRef = this.dialog.open(Patient_trackingComponent, {
        panelClass: "patient-tracking",
        width: "100%",
        //  maxWidth: '55vw',
        // height: '100%',
        data: {
          patientid: patid,
        },
      });

      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe((result) => {
          this.dialog.closeAll();
          //pid = result;
        });
    } else if (flag == "gotoemr") {
      //this.bindemrdata();
      // this.getapicount();
    } else if (flag == "withoutvisit") {
      if (this.opdvisitService.visitdates.length > 0) {
        this.emrservice.visitid = this.opdvisitService.visitdates[0].fK_VisitId;
        let examid = this.opdvisitService.visitdates.filter(
          (item) => item.fK_VisitId == this.emrservice.visitid
        );
        this.emrservice.examid = examid[0].pK_ExamId;
        this.emrservice.visitDate = examid[0].visitDate;
        this.emrservice.billingAmount = examid[0].billingAmount;
        this.emrservice.paidAmount = examid[0].paidAmount;
        this.emrservice.reportingTime = examid[0].reportingTime;
        this.emrservice.returnTime = examid[0].returnTime;
        this.emrservice.visitType = examid[0].visitType;
        this.emrservice.billStatus = examid[0].billStatus;
        this.opdvisitService.visitid = this.emrservice.visitid;
        if (examid[0].doctorId != null && examid[0].doctorId > 0) {
          this.opdvisitService.DoctorIdEmr = examid[0].doctorId;
        } else {
          this.opdvisitService.DoctorIdEmr = examid[0].visitDoctorId;
        }
      } else {
        this.emrservice.visitid = null;
        this.emrservice.visitDate = null;
        this.emrservice.examid = null;
        this.emrservice.billingAmount = null;
        this.emrservice.paidAmount = null;
        this.emrservice.reportingTime = null;
        this.emrservice.returnTime = null;
        this.emrservice.visitType = null;
      }
    }
  }
  failed_visitlist(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  onVisitChange(event) {
    this.emrservice.visitid = event;
    let examid = this.opdvisitService.visitdates.filter(
      (item) => item.fK_VisitId == this.emrservice.visitid
    );
    this.emrservice.examid = examid[0].pK_ExamId;
    this.emrservice.visitDate = examid[0].visitDate;
    this.emrservice.billingAmount = examid[0].billingAmount;
    this.emrservice.paidAmount = examid[0].paidAmount;
    this.emrservice.reportingTime = examid[0].reportingTime;
    this.emrservice.returnTime = examid[0].returnTime;
    this.emrservice.visitType = examid[0].visitType;
    this.opdvisitService.visitid = this.emrservice.visitid;
    if (examid[0].doctorId != null && examid[0].doctorId > 0) {
      this.opdvisitService.DoctorIdEmr = examid[0].doctorId;
    } else {
      this.opdvisitService.DoctorIdEmr = examid[0].visitDoctorId;
    }
  }
  convertTime12Hour(time) {
    if (time != null && time != "") {
      let hour = time.split(":")[0];
      let min = time.split(":")[1];
      let part = hour >= 12 ? "PM" : "AM";

      min = (min + "").length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + "").length == 1 ? `0${hour}` : hour;

      return `${hour}:${min} ${part}`;
    } else {
      return null;
    }
  }
  setagepatient(year: number, months: number, days: number, gender) {
    if (year > 0) {
      this.opdvisitService.printpriciptionAge = year + "/" + gender;
      return "(" + year + "|" + gender + ")";
    } else if (months > 0) {
      this.opdvisitService.printpriciptionAge = months + "/" + gender;
      return "(" + months + "|" + gender + ")";
    } else if (days > 0) {
      this.opdvisitService.printpriciptionAge = days + "/" + gender;
      return "(" + days + "|" + gender + ")";
    } else {
      return "";
    }
  }

  // get Area
  // GetAreaData() {
  //   this.dashboardService.GetArea().subscribe(item => {
  //     this.areaArray = item;
  //     this.AreaControll();
  //   })
  // }

  // AreaControll() {

  //   this.AreaCtrl = new FormControl();
  //   this.filteredAreaArray = this.AreaCtrl.valueChanges
  //     .pipe(
  //       startWith(''),
  //       map(cat => cat ? this.filterAreafunction(cat) : this.areaArray.slice())
  //     );

  // }

  // filterAreafunction(name: string) {

  //   const len = Object.keys(name).length;
  //   if (len > 9) {
  //     return this.areaArray.filter(co =>
  //       co.floor?.toLowerCase().indexOf(name) === 0);
  //   } else {

  //     return this.areaArray.filter(co =>
  //       co.floor?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
  //   }

  // }
  // getAreaobj(e: any) {

  //   var val = e.option.value;
  //   this.ShowAreaName = val.floor;
  //   const areaid = val.pk_FloorId;
  //   if (areaid > 0) {
  //     this.SearchAreatype(areaid);
  //   }

  // }
  // CheckinputArea(event: any) {
  //   var checkdata = event.target.value;
  //   if (checkdata == "") {
  //     this.get_opd_visits();
  //   }
  // }
  // SearchAreatype(reaaid) {
  //   // debugger
  //   this.dataSource.data = this.dataSource.data.filter(patient => patient.fk_FloorId == reaaid);
  //   // this.dataSource.data = area_location_opd_visits;
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.filter = null;

  // }
  GetAreaClinicalData() {
    this.dashboardService
      .GetClinicalDepartment()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item) => {
          this.ClinicalAreaArray = item;
          this.ClinicAreaControll();
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );

  }

  ClinicAreaControll() {
    if (this.dashboardService.ShowClinicAreaName) {
      this.ClinicAreaCtrl = new FormControl(this.dashboardService.ShowClinicAreaName);
    } else {
      this.ClinicAreaCtrl = new FormControl();
    }

    this.filteredClinicAreaArray = this.ClinicAreaCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterClinicAreafunction(cat)
          : this.ClinicalAreaArray.slice()
      )
    );
  }
  // ClinicAreaControll() {
  //   this.ClinicAreaCtrl = new FormControl();
  //   this.clinicAreaSubject.next(this.ClinicalAreaArray);
  //   this.ClinicAreaCtrl.valueChanges.pipe(
  //     startWith(''),
  //     map(value => this.filterClinicAreafunction(value))
  //   ).subscribe(filteredAreas => {
  //     this.clinicAreaSubject.next(filteredAreas);
  //   });

  // }

  // filterClinicAreafunction(name: string) {
  //   const len = Object.keys(name).length;
  //   if (len > 9) {
  //     return this.ClinicalAreaArray.filter(
  //       (co) => co.floor?.toLowerCase().indexOf(name) === 0
  //     );
  //   } else {
  //     return this.ClinicalAreaArray.filter(
  //       (co) => co.floor?.toLowerCase().indexOf(name?.toLowerCase()) === 0
  //     );
  //   }
  // }
  filterClinicAreafunction(value: any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.ClinicalAreaArray.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  // displayClinicAreaName(area: any): string {
  //   return area && area.name ? area.name : '';
  // }

  resetFilteredAreaArray() {
    this.clinicAreaSubject.next(this.ClinicalAreaArray); // Display all options when input is focused
  }
  getClinicAreaobj(event: any) {
    const selectedArea = event.option.value;
    this.dashboardService.ShowClinicAreaName = selectedArea.name;
    const Clinicid = selectedArea.pK_Id;
    this.ClinicAreaCtrl.setValue(selectedArea.name);
    if (Clinicid > 0) {
      this.SearchClinicAreatype(Clinicid);
    }
  }

  SearchClinicAreatype(recaid: number) {
    this.authService.storevisitdata.subscribe(res => {
      if (this.dashboardService.selecteduser == 'ALL') {
        this.dataSource.data = this.searchareadept(res, this.lastlocation, this.dashboardService.ShowCateName, recaid); this.usertype_opd_visits
      } else {
        this.dataSource.data = this.allSearchvisitdata(res, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName, this.dashboardService.selecteduser)
      }
    })

  }
  searchareadept(userarray: any, locationid: any, categoryname: any, areaid: any) {
    if (locationid == 10) {
      return userarray.filter(item => {
        return (
          (locationid > 0 ? item.fK_PatientLocationId == locationid : true) &&
          (this.authService.Loggeduser.usertypeid == locationid ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (areaid > 0 ? item.fK_ClinicalDeptId === areaid : true)
        );
      });
    } else {
      return userarray.filter(item => {
        return (
          (locationid > 0 ? item.fK_PatientLocationId == locationid : true) &&
          (item.fK_PatientLocationId != 10) && (this.authService.Loggeduser.usertypeid == locationid ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (areaid > 0 ? item.fK_ClinicalDeptId === areaid : true)
        );
      });
    }
  }
  allSearchdata(userarray: any, locationid: any, categoryname: any, areaname: any) {

    const areaId = this.ClinicalAreaArray.filter((patient) => patient.name == areaname)[0]?.pK_Id;
    if (locationid == 10) {
      return userarray.filter(item => {
        return (
          (locationid > 0 ? item.fK_PatientLocationId == locationid : true) &&
          (this.authService.Loggeduser.usertypeid == locationid ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (areaId > 0 ? item.fK_ClinicalDeptId === areaId : true)
        );
      });
    } else {
      return userarray.filter(item => {
        return (
          (locationid > 0 ? item.fK_PatientLocationId == locationid : true) &&
          (item.fK_PatientLocationId != 10) &&
          (this.authService.Loggeduser.usertypeid == locationid ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (areaId > 0 ? item.fK_ClinicalDeptId === areaId : true)
        );
      });
    }

  }
  allSearchnotpermissiondata(userarray: any, locationid: any, categoryname: any, areaname: any, userName: any) {

    const areaId = this.ClinicalAreaArray.filter((patient) => patient.name == areaname)[0]?.pK_Id;
    if (locationid == 10) {
      return userarray.filter(item => {
        return (
          (this.authService.Loggeduser.usertypeid > 0 ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (areaId > 0 ? item.fK_ClinicalDeptId === areaId : true) && ((userName ? item.drFullName === userName : true) || (userName ? item.arFullName === userName : true)
            || (userName ? item.arFullName === userName : true) || (userName ? item.opFullName === userName : true) || (userName ? item.proFullName === userName : true) ||
            (userName ? item.phyFullName === userName : true) || (userName ? item.consFullName === userName : true))
        );
      });
    } else {
      return userarray.filter(item => {
        return (
          (this.authService.Loggeduser.usertypeid > 0 ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (item.fK_PatientLocationId != 10) &&
          (areaId > 0 ? item.fK_ClinicalDeptId === areaId : true) && ((userName ? item.drFullName === userName : true) || (userName ? item.arFullName === userName : true)
            || (userName ? item.arFullName === userName : true) || (userName ? item.opFullName === userName : true) || (userName ? item.proFullName === userName : true) ||
            (userName ? item.phyFullName === userName : true) || (userName ? item.consFullName === userName : true))
        );
      });
    }

  }
  allSearchvisitdata(userarray: any, locationid: any, categoryname: any, areaname: any, userName: any) {

    const areaId = this.ClinicalAreaArray.filter((patient) => patient.name == areaname)[0]?.pK_Id;
    if (locationid == 10) {
      return userarray.filter(item => {
        return (
          (locationid > 0 ? item.fK_PatientLocationId == locationid : true) &&
          (categoryname ? item.categoryName === categoryname : true) &&
          (areaId > 0 ? item.fK_ClinicalDeptId === areaId : true) && (this.authService.Loggeduser.usertypeid == locationid ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true)
          && ((userName ? item.drFullName === userName : true) || (userName ? item.arFullName === userName : true)
            || (userName ? item.arFullName === userName : true) || (userName ? item.opFullName === userName : true) || (userName ? item.proFullName === userName : true) ||
            (userName ? item.phyFullName === userName : true) || (userName ? item.consFullName === userName : true))
        );
      });
    } else {
      return userarray.filter(item => {
        return (
          (locationid > 0 ? item.fK_PatientLocationId == locationid : true) &&
          (categoryname ? item.categoryName === categoryname : true) && (item.fK_PatientLocationId != 10) &&
          (areaId > 0 ? item.fK_ClinicalDeptId === areaId : true) && (this.authService.Loggeduser.usertypeid == locationid ? item.fK_PatientLocationId == this.authService.Loggeduser.usertypeid : true)
          && ((userName ? item.drFullName === userName : true) || (userName ? item.arFullName === userName : true)
            || (userName ? item.arFullName === userName : true) || (userName ? item.opFullName === userName : true) || (userName ? item.proFullName === userName : true) ||
            (userName ? item.phyFullName === userName : true) || (userName ? item.consFullName === userName : true))
        );
      });
    }

  }
  CheckinputArea(event: any) {
    const checkdata = event.target.value;
    if (!checkdata) {
      this.dashboardService.ShowClinicAreaName = null;
      this.authService.storevisitdata.subscribe(res => {
        this.successopdvisit(res);
      })
      //  this.get_opd_visits();
    }
  }

  bindemrdata() {
    //header information we required on emr
    this.getheader_data();
    //this.advisedinvestigation_ds = new MatTableDataSource(this.emrservice.advisedinvestigation.slice());
    const flag = "gotoemr";
    // get visit dates based on patient id
    // this.get_visit_dates(this.opdvisitService.patientdetails.pkRegId, flag);

    this.emrservice
      .getemrPermissionuserid()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.emrservice.webMenuPermission = [];
            this.emrservice.historyPermission = {};
            this.emrservice.pasthistoryPermission = {};
            this.emrservice.surgicalhistoryPermission = {};
            this.emrservice.familyhistoryPermission = {};
            this.emrservice.drughistoryPermission = {};
            this.emrservice.socialhistoryPermission = {};
            this.emrservice.otherhistoryPermission = {};
            this.emrservice.primaryExamPermission = {};
            this.emrservice.PresentingComplaintsPermission = {};
            this.emrservice.autorefkeroPermission = {};
            this.emrservice.intraocularPressurePermission = {};
            this.emrservice.oldGlassPermission = {};
            this.emrservice.visionPermission = {};
            this.emrservice.currentMPermission = {};
            this.emrservice.unDilatedAndDilatedPermission = {};
            this.emrservice.glassPrescriptionPermission = {};
            this.emrservice.optometristPermission = {};
            this.emrservice.optoSliptLampPermission = {};
            this.emrservice.advisedInvestigationsPermission = {};
            this.emrservice.postOpInformationPermission = {};
            this.emrservice.doctorPermission = {};
            this.emrservice.findingPermission = {};
            this.emrservice.investigationPermission = {};
            this.emrservice.diagnosisPermission = {};
            this.emrservice.medicinePermission = {};
            this.emrservice.surgeryPermission = {};
            this.emrservice.reviewPermission = {};
            this.emrservice.otherInformationPermission = {};
            this.emrservice.counselorPermission = {};
            this.emrservice.procedurePermission = {};
            this.emrservice.pasthistory = [];
            this.emrservice.surgicalhistory = [];
            this.emrservice.familyhistory = [];
            this.emrservice.drugallergy = [];
            this.emrservice.otherinfo_history = {};
            this.emrservice.webMenuPermission = x.filter(
              (item) => (item.webMenuTypeId == 2 || item.webMenuTypeId == 3) && item.webIsMenu == true && item.pk_WebMenuUserPermissionDetailId != null
            );
            if (this.emrservice.webMenuPermission.length > 0) {
              this.emrservice.webMenuPermission.forEach((item) => {
                switch (item.menuDetailName) {

                  case "mnuHistory": {
                    this.emrservice.historyPermission = item;
                    break;
                  }
                  case "mnuHistorySystemic": {
                    this.emrservice.pasthistoryPermission = item;

                    break;
                  }
                  case "mnuHistorySurgical": {
                    this.emrservice.surgicalhistoryPermission = item;
                    break;
                  }
                  case "mnuHistoryFamily": {
                    this.emrservice.familyhistoryPermission = item;

                    break;
                  }
                  case "mnuHistoryDrugAllergy": {
                    this.emrservice.drughistoryPermission = item;

                    break;
                  }
                  case "mnuHistorySocial": {
                    this.emrservice.socialhistoryPermission = item;

                    break;
                  }
                  case "mnuHistoryOtherInformation": {
                    this.emrservice.otherhistoryPermission = item;

                    break;
                  }
                  case "mnuPrimaryExam": {
                    this.emrservice.primaryExamPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamPresentingComplaints": {
                    this.emrservice.PresentingComplaintsPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamAutoRefraction&Keratometer": {
                    this.emrservice.autorefkeroPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamIntraocularPressure": {
                    this.emrservice.intraocularPressurePermission = item;
                    break;
                  }
                  case "mnuPrimaryExamOldGlass": {
                    this.emrservice.oldGlassPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamVision": {
                    this.emrservice.visionPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamCurrentMedication": {
                    this.emrservice.currentMPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamUn-Dilated And Dilated": {
                    this.emrservice.unDilatedAndDilatedPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamGlassPrescription": {
                    this.emrservice.glassPrescriptionPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamOPDTest": {
                    this.emrservice.optometristPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamAdvisedInvestigations": {
                    this.emrservice.advisedInvestigationsPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamOptoSlitLampExamination": {
                    this.emrservice.optoSliptLampPermission = item;
                    break;
                  }
                  case "mnuPrimaryExamPostOpInformation": {
                    this.emrservice.postOpInformationPermission = item;
                    break;
                  }
                  case "mnuDoctorOtherInformation": {
                    this.emrservice.otherInformationPermission = item;
                    break;
                  }
                  case "mnuDoctor": {
                    this.emrservice.doctorPermission = item;
                    break;
                  }
                  case "mnuDoctorFinding[Examination]": {
                    this.emrservice.findingPermission = item;
                    break;
                  }
                  case "mnuDoctorInvestigation": {
                    this.emrservice.investigationPermission = item;
                    break;
                  }
                  case "mnuDoctorDiagnosis": {
                    this.emrservice.diagnosisPermission = item;
                    break;
                  }
                  case "mnuDoctorMedicine": {
                    this.emrservice.medicinePermission = item;
                    break;
                  }
                  case "mnuDoctorSurgery": {
                    this.emrservice.surgeryPermission = item;
                    break;
                  }
                  case "mnuDoctorReview": {
                    this.emrservice.reviewPermission = item;
                    break;
                  }
                  case "mnuCounselor": {
                    this.emrservice.counselorPermission = item;
                    break;
                  }
                  case "mnuProcedure": {
                    this.emrservice.procedurePermission = item;
                    break;
                  }
                }
              });
              if (
                this.emrservice.historyPermission?.webIsMenu == true &&
                this.emrservice.historyPermission
                  ?.pk_WebMenuUserPermissionDetailId != null) {
                this.callForkjoin();
              } else {
                this.dialog.closeAll();
                this.opdvisitService.visitdates = [];
                var cacheBuster = Date.now();
                if (this.authService.Loggeduser.specialityId == 1) {
                  this.route.navigate(["/layout/EMR"], {
                    queryParams: { v: cacheBuster },
                    replaceUrl: true,
                  });
                } else if (this.authService.Loggeduser.specialityId == 2) {
                  this.route.navigate(["/layout/DentalEmr"], {
                    queryParams: { v: cacheBuster },
                    replaceUrl: true,
                  });
                }
              }
            } else {
              if (
                this.authService.masterdata.defaultView != "C" ||
                this.authService.masterdata.defaultView != null ||
                this.authService.masterdata.defaultView != ""
              ) {
                if (
                  this.emrservice.historyPermission?.webIsMenu == true &&
                  this.emrservice.historyPermission
                    ?.pk_WebMenuUserPermissionDetailId != null
                ) {
                  this.callForkjoin();
                } else {
                  this.dialog.closeAll();
                  this.opdvisitService.visitdates = [];
                  var cacheBuster = Date.now();
                  if (this.authService.Loggeduser.specialityId == 1) {
                    this.route.navigate(["/layout/EMR"], {
                      queryParams: { v: cacheBuster },
                      replaceUrl: true,
                    });
                  } else if (this.authService.Loggeduser.specialityId == 2) {
                    this.route.navigate(["/layout/DentalEmr"], {
                      queryParams: { v: cacheBuster },
                      replaceUrl: true,
                    });
                  }
                }
              } else {
                this.dashboardService.openSnackBar(
                  "Please give Emr Menu Permission",
                  "ok"
                );
              }
            }
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );

    // history tab data filled bcoz it based on patientid not visit id
  }

  callForkjoin() {
    forkJoin({
      pasthistorydata: this.emrservice.pasthistoryPermission?.webIsMenu == true ? this.emrservice.get_pasthistory(this.opdvisitService.visitid) : of([]),
      surgeriesdata: this.emrservice.surgicalhistoryPermission?.webIsMenu == true ? this.emrservice.get_surgeries(this.opdvisitService.visitid) : of([]),
      failyhistorydata: this.emrservice.familyhistoryPermission?.webIsMenu == true ? this.emrservice.get_familyhistory() : of([]),
      drugallerergydata: this.emrservice.drughistoryPermission?.webIsMenu == true ? this.emrservice.get_allergies() : of([]),
      otherinfodata: this.emrservice.otherhistoryPermission?.webIsMenu == true ? this.emrservice.get_otherinfo() : of({}),
    })
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (results: any) => {
          this.emrservice.pasthistory = results.pasthistorydata;
          this.emrservice.surgicalhistory = results.surgeriesdata;
          this.emrservice.familyhistory = results.failyhistorydata;
          this.emrservice.drugallergy = results.drugallerergydata;
          this.emrservice.otherinfo_history = results.otherinfodata;
          this.dialog.closeAll();
          this.emrservice.visitid = null;
          this.opdvisitService.visitdates = [];
          var cacheBuster = Date.now();
          if (this.authService.Loggeduser.specialityId == 1) {
            this.route.navigate(["/layout/EMR"], {
              queryParams: { v: cacheBuster },
              replaceUrl: true,
            });
          } else if (this.authService.Loggeduser.specialityId == 2) {
            this.route.navigate(["/layout/DentalEmr"], {
              queryParams: { v: cacheBuster },
              replaceUrl: true,
            });
          }
        },
        (err) => {
          this.dialog.closeAll();
          this.dashboardService.openSnackBar("API Failed", "ok");
        }
      );
  }



  getheader_data() {
    // this.opdvisitService.getpartymaster();
    //  this.opdvisitService.getpersonmaster("OPDVISIT", 0);
    this.opdvisitService.get_otherinformation_tab_dd("BLOODGROUP"); // for blood group
  }

  open_trackingsummary(patientid: number) {
    // console.log(patientid);
    const flag = "tracking";
    this.get_visit_dates(patientid, flag);
  }
  colorcode: any;
  useDefault: boolean = false;
  modechaged(event) {
    if (event.checked == true) {
      return (this.colorcode = "#3B9C9C");
    } else {
      return (this.colorcode = null);
    }
  }

  getname_pattern() {
    this.dashboardService._getname_pattern();
  }

  gettime_slots() {
    this.dashboardService._gettime_slots();
  }

  getuserlist_default() {
    switch (this.authService.Loggeduser.usertypeid) {
      case 9: {
        this.dashboardService
          .getall_doctors()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      case 6: {
        this.dashboardService
          .getall_doctors()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      case 1: {
        this.dashboardService
          .getall_doctors()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      //Clinical Department
      case 3: {
        this.dashboardService
          .getall_cds()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      // 4	Auto Ref
      case 4: {
        this.dashboardService
          .getall_ars()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      // 5	Optometrist
      case 5: {
        this.dashboardService
          .getall_ops()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      // 7	Counselor
      case 7: {
        this.dashboardService
          .getall_css()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
      // 8	Procedure
      case 8: {
        this.dashboardService
          .getall_prs()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.success_usernamedd(data),
            (err) => this.failed_usernamedd(err)
          );
        break;
      }
    }
  }

  success_usernamedd(data) {
    // this.locationsubfilterlist = data;

    this.locationsubfilterlist = data;
    this.userControll();
  }

  failed_usernamedd(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  getappointment_details() {
    if (this.authService.Loggeduser.usertypeid == 6) {
      this.getdoctors_appointment_details();
    } else {
      this.gethospital_appointment_details();
    }
  }

  getdoctors_appointment_details() {
    this.getdoc_total_appointments();
    this.getdoc_pending_appointments();
    this.getdoc_booked_appointments();
    this.getdoc_cancled_appointments();
  }

  gethospital_appointment_details() {
    this.gethospital_total_appointments();
    this.gethospital_pending_appointments();
    this.gethospital_booked_appointments();
    this.gethospital_cancled_appointments();
  }

  getdoc_total_appointments() {
    this.dashboardService._getdoc_total_appointments();
  }
  getdoc_pending_appointments() {
    this.dashboardService._getdoc_pending_appointments();
  }
  getdoc_booked_appointments() {
    this.dashboardService._getdoc_booked_appointments();
  }
  getdoc_cancled_appointments() {
    this.dashboardService._getdoc_cancled_appointments();
  }

  gethospital_total_appointments() {
    this.dashboardService._gethospital_total_appointments();
  }
  gethospital_pending_appointments() {
    this.dashboardService._gethospital_pending_appointments();
  }
  gethospital_booked_appointments() {
    this.dashboardService._gethospital_booked_appointments();
  }
  gethospital_cancled_appointments() {
    this.dashboardService._gethospital_cancled_appointments();
  }

  successopdvisit(data) {

    this.authService.storevisitdata = of(data);

    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    // this.dataSource.filter = null;
    this.searchstring = "";
    this.showgrid = true;
    this.q = 1;
    this.selectedcategory = 0;
    if (this.checkfilteravlue == 1) {
      this.selectedusername = "ALL";
      this.usertypeid = 9;
    } else {

      if (
        this.authService.Loggeduser.usertypeid != 9 && this.authService.Loggeduser.usertypeid != 1 && !this.authService.checkfirsttimeload
      ) {
        this.selectedusername = this.authService.users.filter(item => item.pkUserId == this.authService.Loggeduser.userid)[0]?.userName;
        this.dashboardService.selecteduser = this.selectedusername;
      } else if (this.dashboardService.selecteduser) {
        this.selectedusername = this.dashboardService.selecteduser
      } else {
        this.selectedusername = "ALL";
      }
    }

    // //console.log("data" + JSON.stringify(data));
    this.opd_visits = data.reduce((acc, current) => {
      const x = acc.find((item) => item.pK_VisitId === current.pK_VisitId);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    this.opdvisitService.opdvisits = this.opd_visits;

    if (this.dashboardService.selecteduser == "ALL") {

      this.dataSource.data = this.allSearchdata(this.opd_visits, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName)
    } else {
      this.dataSource.data = this.allSearchvisitdata(this.opd_visits, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName, this.dashboardService.selecteduser);
    }

    //graph data binding
    this.dashboardService.showspinner = false;
    this.FreshCount = this.opdvisitService.opdvisits.filter(
      (patient) => patient.isReview === false
    ).length;
    this.reviewCount = this.opdvisitService.opdvisits.filter(
      (patient) => patient.isReview === true
    ).length;
    this.dilatedCount = this.opdvisitService.opdvisits.filter(
      (patient) => patient.isDilated !== 0
    ).length;
    this.doughnutRightData = [
      {
        data: [this.FreshCount, this.reviewCount],
        label: "Fresh Count",
        borderWidth: 0,
      },
    ];

    // if (this.lastlocation) {
    //   this.filterbasedonlocation(this.lastlocation, false);
    // }

    this.opdvisitService.opdvisit_list = this.dataSource.data;
    // this.authService.checkfirsttimeload = false;
    this.getcopyapidata();
  }

  getcopyapidata() {
    this.authService.getcheckSIngal();
  }

  failedopdvisit(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "ok");
    }
    this.dashboardService.showspinner = false;
  }

  getpatiendId(element: any) {
   
    this.SelectedPatientObj = element;
     this.opdvisitService.patientdetails.pkRegId = element.fK_RegID;
    this.opdvisitService.get_old_photo();

    //console.log('selecetd p', this.SelectedPatientObj);
    // setTimeout( () => {
    //  document.getElementById("BillingResonModel").style.display = "block";
    //  }, 500 );
  }

  closeselecteddata() {
    document.getElementById("BillingResonModel").style.display = "none";
    this.SelectedPatientObj = {};
  }
  clearModal() {
    this.selectedRowIndex = -1;
  }
  getpatiendIdfortransfer(element: any) {

    this.SelectedPatientObj = element;
    this.selectedRowIndex = element.pK_VisitId
    this.locationId = element.fK_PatientLocationId;
    this.SelectedPatientObj = element;
    this.dashboardService.selectedPatient = this.SelectedPatientObj;
    this.opdvisitService.patientdetails.pkRegId = element.fK_RegID;
    this.opdvisitService.get_old_photo();
    if (this.SelectedPatientObj.usercons == true) {
      this.dashboardService.subscriptions = this.dashboardService
        .getCouncelorStatus(element.fK_RegID)
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => {
            let getcounsDate = data[0].surgeryDate;
            let counsDate = moment(getcounsDate).format("YYYY-MM-DD");
            this.dashboardService.openSnackBar(
              this.authService.validationMsg["dashboardValidMsg.msg9"] +
              counsDate,
              this.authService.validationMsg["Ok"]
            );
          },
          (err) => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar(
                "You Don't have Permission",
                "OK"
              );
            } else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
    //console.log('selecetd p', this.SelectedPatientObj);
    // setTimeout( () => {
    //  document.getElementById("TranferModel").style.display = "block";
    //  }, 500 );
  }

  closetrasnferdata() {
    this.closebutton.nativeElement.click();
    this.SelectedPatientObj = {};
  }

  fillusers(
    isDilated: number,
    pid: number,
    pname: string,
    usertypeid: number,
    prelocid: number
  ) {
    if (this.authService.masterdata.isPatientTransfer == true) {
      if (this.locationId == usertypeid && usertypeid == 1) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg10"],
          this.authService.validationMsg["Ok"]
        );
      }
      if (this.locationId == usertypeid && usertypeid == 9) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg11"],
          this.authService.validationMsg["Ok"]
        );
      }
      if (this.locationId == usertypeid && usertypeid == 10) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg12"],
          this.authService.validationMsg["Ok"]
        );
      }
      this.open_loader_Dialog();
      // return
      if (usertypeid == 10) {
        if (isDilated != 1) {
          this.return_patient(pid, prelocid);
        } else {
          this.dashboardService.openSnackBar(
            this.authService.validationMsg["dashboardValidMsg.msg13"],
            this.authService.validationMsg["Ok"]
          );
        }
      } else if (usertypeid == 1) {
        this.move_patient_reception(pid, prelocid);
      } else if (usertypeid == 9) {
        this.move_patient_waiting(pid, prelocid);
      } else {
        this.selectedRowIndex = pid;
        //this.dashboardService.showspinner = true;
        this.dashboardService.pid = pid;
        this.dashboardService.pname = pname;
        this.dashboardService.locationid = usertypeid;
        this.dashboardService.prelocationid = prelocid;

        this.get_usertype_list(usertypeid);
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg14"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  move_patient_waiting(visitid: number, prelocationid: number) {
    this.openWaitingDialog(visitid);
  }

  return_patient(visitid: number, prelocationid: number) {
    this.dashboardService.subscriptions = this.dashboardService
      .getlocationType(
        visitid,
        this.authService.Loggeduser.userid,
        0,
        this.authService.Loggeduser.branchid,
        prelocationid,
        10,
        0
      )
      .pipe(takeUntil(this.destroydashboard$))
      // this.http.put<any>(this.dashboardService.newbaseUrl + "VisitMaster/UpdateLocation/" +
      //   visitid + "/" + this.authService.Loggeduser.userid + "/" +
      //   0 + "/" +
      //   this.authService.Loggeduser.branchid + "/" + prelocationid + "/" + 10
      //   + "/" + "0", [])
      .subscribe(
        (data) => this.success_patient_moved(data),
        (err) => this.failed_patient_moved(err)
      );
  }
  success_patient_moved(data) {

    this.dashboardService.openSnackBar(
      this.authService.validationMsg["dashboardValidMsg.msg15"],
      this.authService.validationMsg["Ok"]
    );
    this.ChangeCallStatus(this.SelectedPatientObj.fK_RegID, this.authService.Loggeduser.room, this.authService.Loggeduser.roomid, 'RETURN');
    this.refresh_opd_visits();
    this.closetrasnferdata();
  }
  failed_patient_moved(err) {
    this.closetrasnferdata();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg16"],
        this.authService.validationMsg["Ok"]
      );
    }

    this.refresh_opd_visits();
  }

  move_patient_reception(visitid: number, prelocationid: number) {
    this.dashboardService.subscriptions = this.dashboardService
      .getlocationType(
        visitid,
        this.authService.Loggeduser.userid,
        0,
        this.authService.Loggeduser.branchid,
        prelocationid,
        1,
        0
      )
      .pipe(takeUntil(this.destroydashboard$))
      // this.http.put<any>(this.dashboardService.newbaseUrl + "VisitMaster/UpdateLocation/" +
      //   visitid + "/" + this.authService.Loggeduser.userid + "/" +
      //   0 + "/" +
      //   this.authService.Loggeduser.branchid + "/" + prelocationid + "/" + 1
      //   + "/" + "0", [])
      .subscribe(
        (data) => this.success_patient_moved_reception(data),
        (err) => this.failed_patient_moved_reception(err)
      );
  }
  success_patient_moved_reception(data) {
    this.refresh_opd_visits();
    this.ChangeCallStatus(this.SelectedPatientObj.fK_RegID, this.authService.Loggeduser.room, this.authService.Loggeduser.roomid, 'TRANSFER');

    this.dashboardService.openSnackBar(
      this.authService.validationMsg["dashboardValidMsg.msg17"],
      this.authService.validationMsg["Ok"]
    );
    this.closetrasnferdata();

  }
  failed_patient_moved_reception(err) {
    this.closetrasnferdata();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg16"],
        this.authService.validationMsg["Ok"]
      );
    }

    this.refresh_opd_visits();
  }

  get_usertype_list(usertypeid: number) {
    if (usertypeid == 6) {
      this.dashboardService
        .getall_doctors()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 5) {
      this.dashboardService
        .getall_ops()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 4) {
      this.dashboardService
        .getall_ars()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 3) {
      this.dashboardService
        .getall_cds()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 7) {
      this.dashboardService
        .getall_css()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 8) {
      this.dashboardService
        .getall_prs()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    }
    // physician in advanced Netram location id changed 23 to 21
    else if (usertypeid == 21) {
      this.dashboardService
        .getall_physicians()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else {
      this.dialog.closeAll();
    }
  }
  success_usertype_list(data) {
    if (this.gridView == false) {
      this.dashboardService.usertype_list = data;
    } else {
      this.dashboardService.usertype_list = data;
      this.dialog.closeAll();
      this.getusertype();
      this.openDialog();
    }
  }
  getusertype() {
    switch (this.dashboardService.locationid) {
      case 3: {
        this.dashboardService.usertypestring = "CD(S)";
        break;
      }
      case 4: {
        this.dashboardService.usertypestring = "AR(S)";
        break;
      }
      case 5: {
        this.dashboardService.usertypestring = "OP(S)";
        break;
      }
      case 6: {
        this.dashboardService.usertypestring = "DOCTOR(S)";
        break;
      }
      case 7: {
        this.dashboardService.usertypestring = "CS(S)";
        break;
      }
      case 8: {
        this.dashboardService.usertypestring = "PR(S)";
        break;
      }
      case 21: {
        this.dashboardService.usertypestring = "PHY(S)";
        break;
      }
    }
  }

  failed_usertype_list(err) {
    this.dashboardService.pid = null;
    this.dashboardService.pname = null;
    this.dashboardService.locationid = null;
    this.dashboardService.prelocationid = null;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "ok");
    }
  }

  openWaitingDialog(visitid: number): void {
    const dialogRef = this.dialog.open(WaitingReasonComponent, {
      panelClass: "full-width-dialog",

      height: "30%",
      width: "40%",
      data: {
        // remark: remark,
        visitid: visitid,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        this.dialog.closeAll();
        if (this.dashboardService.waitingreason == true) {
          this.closetrasnferdata();
          this.refresh_opd_visits();
        }

        //pid = result;
      });
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(PatientMoveDialogComponent, {
      width: "800px",
      data: {
        name: this.dashboardService.pname,
        id: this.dashboardService.pid,
        usertypeid: this.dashboardService.locationid,
        userid: this.authService.Loggeduser.userid,
        prelocationid: this.dashboardService.prelocationid,
        usertype: this.dashboardService.usertypestring,
        patientInfo: this.dashboardService.selectedPatient,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {

        // this.selectedRowIndex = -1;
        if (this.dashboardService.popup_cancel != true) {

          this.refresh_opd_visits();
          if (result != '0' && result != null) {
            this.ChangeCallStatus(this.SelectedPatientObj.fK_RegID, result.roomName, result.loginroomId, 'TRANSFER');
          }
          this.closetrasnferdata();
        }
        this.dialog.closeAll();

        //pid = result;
      });
  }

  fillremarks(
    patientName: any,
    patid: number,
    visitid: number,
    initial: string
  ) {
    // debugger
    // call the api here and in its subscription open dialog
    //this.dashboardService.showspinner = true;
    this.dashboardService.patientname = patientName;
    this.dashboardService.pid = patid;
    this.dashboardService.visitid = visitid;
    this.dashboardService.initial = initial;
    this.open_remarks_Dialog();
    // get all remarks first
    // this.dashboardService.get_dashboard_remark().pipe(takeUntil(this.destroydashboard$)).subscribe(
    //   (data) => this.successremark_all(data),
    //   (err) => this.failedremark_all(err)
    // );
  }
  // successremark_all(data) {
  //   this.dashboardService.allremarks = data;
  //   this.open_remarks_Dialog();
  // }
  // failedremark_all(err) {
  //   if (err.status == 403) {
  //     this.dashboardService.openSnackBar("You Don't have Permission", "OK");
  //   } else {
  //     this.dashboardService.openSnackBar(
  //       this.authService.validationMsg["dashboardValidMsg.msg19"],
  //       this.authService.validationMsg["Ok"]
  //     );
  //   }

  // }
  selectedUpgradePackage(e) {
    this.checkSearchType = e;
  }

  customSearchFillter(searchdata) {
    var found = this.dataSource.data.find((e) => e.patientName === searchdata);
  }

  startdialation(
    LocationId: number,
    isdialated: number,
    visitid: number,
    uhid: number,
    patientName: string
  ) {
    if (LocationId != 10) {
      let d1 = new Date(this.dashboardService.selecteddate);
      // todays date
      let d2 = new Date(this.authService.localDate);

      var month = d1.getUTCMonth() + 1; //months from 1-12
      var day = d1.getUTCDate();
      var year = d1.getUTCFullYear();

      var month1 = d2.getUTCMonth() + 1; //months from 1-12
      var day1 = d2.getUTCDate();
      var year1 = d2.getUTCFullYear();

      let olddate = day + "/" + month + "/" + year;
      let todaysdate = day1 + "/" + month1 + "/" + year1;

      if (olddate == todaysdate) {
        if (isdialated == 0) {
          this.gethelplist(visitid, uhid, patientName);
          //this.open_start_dialation_Dialog(patid, uhid);
        } else if (isdialated == 1) {
          this.finishdilation(visitid, uhid);
        } else {
          this.removedilation(visitid, uhid);
        }
      } else {
        this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg20"],
          this.authService.validationMsg["Ok"]
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg21"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  gethelplist(patid: number, uhid: number, patientName: string) {
    this.dashboardService.showspinner = true;
    //http://49.50.108.154:7575/api/DynamicHelpList/GetDilationMedicine/DILATEDWITH
    // console.log(this.dashboardService.newbaseUrl + "Common/GetDilationMedicine/DILATEDWITH")
    this.dashboardService
      .getDailationDetail()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => this.success_helplist(data, patid, uhid, patientName),
        (err) => this.failed_helplist(err)
      );
  }

  success_helplist(data, patid: number, uhid: number, patientName: string) {
    this.dashboardService.showspinner = false;
    this.dashboardService.helplist = data;

    this.open_start_dialation_Dialog(patid, uhid, patientName);
  }
  failed_helplist(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg19"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  removedilation(patid: number, uhid: number) {
    this.open_remove_dialation_Dialog(patid, uhid);
  }

  finishdilation(patid: number, uhid: number) {
    this.open_finish_dialation_Dialog(patid, uhid);
  }
  open_remove_dialation_Dialog(patid: number, uhid: number): void {
    const dialogRef = this.dialog.open(RemoveDilationComponent, {
      panelClass: "full-width-dialog",
      // width: '400px',
      data: {
        patid: patid,
        uhid: uhid,
        //userid: this.authService.Loggeduser.userid
      },
      autoFocus: false,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        if (this.dashboardService.popup_cancel != true) {
          this.refresh_opd_visits();
          //console.log('The dialog was closed');
        }
        this.dialog.closeAll();

        //pid = result;
      });
  }
  open_finish_dialation_Dialog(patid: number, uhid: number): void {
    const dialogRef = this.dialog.open(FinishDilationComponent, {
      panelClass: "full-width-dialog",
      // width: '400px',
      data: {
        patid: patid,
        uhid: uhid,
        //userid: this.authService.Loggeduser.userid
      },
      autoFocus: false,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        if (this.dashboardService.popup_cancel != true) {
          this.refresh_opd_visits();
        }

        //console.log('The dialog was closed');
        this.dialog.closeAll();
        //pid = result;
      });
  }

  open_start_dialation_Dialog(
    patid: number,
    uhid: number,
    patientName: string,
  ): void {
    const dialogRef = this.dialog.open(DialationStartsComponent, {
      panelClass: "full-width-dialog",
      width: "43%",

      data: {
        patid: patid,
        uhid: uhid,
        patientName: patientName
        //userid: this.authService.Loggeduser.userid
      },
      //autoFocus: false
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        if (this.dashboardService.popup_cancel != true) {
          this.refresh_opd_visits();
          //console.log('The dialog was closed');
        }
        this.dialog.closeAll();

        //pid = result;
        this.dashboardService.helplist = null;
      });
  }

  open_remarks_Dialog(): void {
    const dialogRef = this.dialog.open(RemarksComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      // height: '50%',
      width: "50%",
      data: {
        id: this.dashboardService.pid,
        userid: this.authService.Loggeduser.userid,
        patname: this.dashboardService.patientname,
        patint: this.dashboardService.initial,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        //console.log('The dialog was closed');
        this.dialog.closeAll();
        this.get_opd_visits();
        //pid = result;
      });
  }

  open_loader_Dialog(): void {
    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: "300px",
      panelClass: "site-loader",
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        //console.log('The dialog was closed');
        // this.open_loader_Dialog();
        //pid = result;
      });

    setInterval(() => {
      dialogRef.close();
    }, 1250);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getcount(locationid: number) {
    // return this.opd_visits.length;

    // return all patients count
    if (locationid == 0) {
      return this.dataSource.data?.filter(
        (patient) => patient.fK_PatientLocationId != 10
      ).length;
      //return this.opd_visits.
      //filter(patient => patient.fK_PatientLocationId != 10).length;
    }
    // return all patients based on user logged in
    else if (locationid == 100) {
      // when user 2- 8 logged in 100 is just a dummy value
      return this.dataSource.data.length;
      // return this.usertype_opd_visits.length;
    } else {
      return this.opd_visits.filter(
        (patient) => patient.fK_PatientLocationId === locationid
      ).length;
    }
    //return this.dataSource.data.filter(patient => patient.fK_PatientLocationId === locationid).length;
  }

  filterbasedonlocation(locationid: number, checkdisable: any) {
    this.dashboardService
      .getopdvisit()
      .pipe(takeUntil(this.destroydashboard$)).subscribe((data: any) => {
        this.authService.storevisitdata = of(data);
        this.authService.checkfirsttimeload = false;
        this.opd_visits = data.reduce((acc, current) => {
          const x = acc.find((item) => item.pK_VisitId === current.pK_VisitId);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
        this.opdvisitService.opdvisits = this.opd_visits;
        if (checkdisable == false) {
          // this.selectedcategory = 0;
          // this.selecteduser = this.selectedusername;
          this.locationsubfilterlist = null;
          this.lastlocation = locationid;

          if (locationid == -1) {
            // this.location_opd_visits = this.opd_visits.slice()
            this.location_opd_visits = this.opd_visits;
            this.dashboardService.selectedlocationid = locationid;
            // as page back to original list popup the username again

            this.getuserlist_default();
            // this.location_opd_visits = [];
            this.dataSource.data = this.location_opd_visits;
          }

          // IN Hospital (Patients)
          else if (locationid == 0) {
            this.location_opd_visits = this.opd_visits;
            //Return
            // filter(patient => patient.fK_PatientLocationId != 10);
            this.dashboardService.selectedlocationid = locationid;
            // as page back to original list popup the username again
            this.getuserlist_default();
            this.dataSource.data = this.location_opd_visits;
          }

          //my list
          else if (locationid == 100) {
            this.location_opd_visits = this.usertype_opd_visits;
            // as page back to original list popup the username again
            this.dashboardService.selectedlocationid = locationid;
            this.getuserlist_default();
            this.dataSource.data = this.location_opd_visits;
          }
          // based on location selection
          else {
            // this.location_opd_visits = this.opd_visits.filter(
            //   (patient) => patient.fK_PatientLocationId === locationid
            // );
            this.dashboardService.selectedlocationid = locationid;
            //make subfilter list

            //  this.subfilter(locationid);
            if (this.dashboardService.selecteduser == 'ALL') {
              this.dataSource.data = this.allSearchdata(this.opd_visits, locationid, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName);
            } else {
              // this.userfilterwithlocation(this.location_opd_visits, this.selecteduser, locationid);
              this.dataSource.data = this.allSearchvisitdata(this.opd_visits, locationid, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName, this.dashboardService.selecteduser);
            }

          }

          // this.dataSource.data = this.location_opd_visits;

          this.searchstring = "";

          //this.modeselect = null;

          //  this.location_opd_visits = [];
        } else {

          this.dataSource.data = this.allSearchnotpermissiondata(this.opd_visits, locationid, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName, this.dashboardService.selecteduser);
          this.dashboardService.openSnackBar(
            this.authService.validationMsg["dashboardValidMsg.msg22"],
            this.authService.validationMsg["Ok"]
          );
        }
      });
  }
  userfilterwithlocation(locationdata: any, selecteduser: string, locationlid) {
    switch (locationlid) {
      //doctor, admin or reception
      case 9: {
        //console.log("its working");
        this.user_filter = locationdata.filter(
          (patient) => patient.drFullName === selecteduser
        );
        break;
      }

      case 6: {
        this.user_filter = locationdata.filter(
          (patient) => patient.drFullName === selecteduser
        );
        break;
      }
      case 1: {
        this.user_filter = locationdata.filter(
          (patient) => patient.drFullName === selecteduser
        );
        break;
      }
      // Auto ref
      case 4: {
        this.user_filter = locationdata.filter(
          (patient) => patient.arFullName === selecteduser);
        break;
      }
      // optitioner
      case 5: {
        this.user_filter = locationdata.filter(
          (patient) => patient.opFullName === selecteduser
        );
        //console.log("Usertype op" + this.user_filter.length);
        break;
      }

      case 7: {
        break;
      }
      // procedure
      case 8: {
        this.user_filter = locationdata.filter(
          (patient) => patient.proFullName === selecteduser
        );
        break;
      }
      //physician chaged location id 23 to 21
      case 21: {
        this.user_filter = locationdata.filter(
          (patient) => patient.phyFullName === selecteduser
        );
        break;
      }

    }
    this.dataSource.data = this.user_filter;
    this.searchstring = "";
  }
  userfilter(selecteduser: string) {

    if (this.authService.masterdata.isUserNameLock == false) {
      this.dashboardService.selecteduser = selecteduser;
      this.selectedusername = selecteduser;
      this.authService.storevisitdata.subscribe(res => {
        if (selecteduser == "ALL") {
          this.dataSource.data = this.allSearchdata(res, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName);

        } else {
          this.dataSource.data = this.allSearchvisitdata(res, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName, this.dashboardService.selecteduser);
        }
      })


      this.searchstring = "";
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg22"],
        this.authService.validationMsg["Ok"]
      );
    }
  }
  // public displayProperty(value) {
  //   if (value) {
  //     return value.categoryName;
  //   }
  // }
  onFocus() {
    this.filteredCatArray = this.CatCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.dashboardService.categories.slice()
          : this.dashboardService.categories.slice()
      )
    );
  }
  onFocusUser() {
    this.filteredUserArray = this.userCtrl.valueChanges.pipe(
      startWith(""),
      switchMap((value) => value ? this._filter(value) : this.megyek)
    );
  }
  getcategoryobj(e: any) {
    var val = e.option.value;
    this.dashboardService.ShowCateName = val.categoryName;
    this.CatCtrl.setValue(val.categoryName);
    if (val.pkCategoryId > 0) {
      this.filterviacategory(val.pkCategoryId);
    }

  }
  filterviacategory(categoryid: number) {
    //console.log("catid " + categoryid);

    // this.selectedusername = "ALL";
    this.authService.storevisitdata.subscribe(res => {

      if (this.dashboardService.selecteduser == 'ALL') {
        this.dataSource.data = this.allSearchdata(res, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName);
      } else {
        this.dataSource.data = this.allSearchvisitdata(res, this.lastlocation, this.dashboardService.ShowCateName, this.dashboardService.ShowClinicAreaName, this.dashboardService.selecteduser);
      }
    })

    this.searchstring = "";
  }

  getToday(): string {
    return this.authService.getServerDate;
  }

  getreferredbyname(refferid: number) {
    //this.getpersonmaster(refferid);
  }

  //  getpersonmaster(rid: number) {
  //   this.http.get<any>(this.dashboardService.baseUrl + "PersonMaster").
  //     subscribe(data => this.success_personmaster(data,rid), err => this.failed_personmaster(err));
  // }
  // success_personmaster(data,rid) {
  //   this.opdvisitService.personmaster = data;
  //   const refferbyname = this.opdvisitService.personmaster.find(rb => rb.pkPersonId == rid);
  //   return refferbyname.personName;

  // }
  // failed_personmaster(err) {

  // }

  subfilter(locationid: number) {
    //this single line code will copy unique values from opdfilter list
    switch (locationid) {
      //if location id is 1
      case 1: {
        this.getuserlist_default();
        break;
      }
      //if location id is 2 (History & Examination)
      case 2: {
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.fK_HEId)));
        // break;
      }
      //if location id is 3 (Clinical department)
      case 3: {
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.fK_ClinicalDeptId)));
        // break;
      }
      //if location id is 4 (Auto Ref)
      case 4: {
        //  this.locationsubfilterlist = this.location_opd_visits;
        this.getuserlist_default();
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //  .map((item: any) => item.ar)));
        break;
      }
      //if location id is 5 (optometrist)
      case 5: {
        this.getuserlist_default();
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.op)));
        break;
      }
      //if location id is 6 (Doctor)
      case 6: {
        this.getuserlist_default();
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.dr)));
        break;
      }
      //if location id is 7 (Counselor)
      case 7: {
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.fK_CouncelorId)));
        break;
      }
      //if location id is 8 (Procedure)
      case 8: {
        this.getuserlist_default();
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.pro)));
        break;
      }
      //if location id is 9 (Admin)
      case 9: {
        // this.locationsubfilterlist = Array.from(new Set(this.opdfilter
        // .map((item: any) => item.fK_HEId)));
        break;
      }
      //if location id is 10 (physician)
      case 21: {
        this.getuserlist_default();
        // this.locationsubfilterlist = Array.from(new Set(this.location_opd_visits
        //   .map((item: any) => item.phy)));
        break;
      }
    }
  }

  filterby_todays_date(checkfivalue) {

    if (
      (this.authService.masterdata.isUserNameLock == false &&
        this.authService.masterdata.isLockLocation == false) ||
      checkfivalue == 0
    ) {
      this.lastlocation = null;
      this.checkfilteravlue = checkfivalue;
      if (checkfivalue == 1) {
        this.userCtrl.setValue('');
        this.CatCtrl.setValue('');
        this.ClinicAreaCtrl.setValue('');
        this.selectedusername = "ALL";
        this.dashboardService.selecteduser = 'ALL';
        this.dashboardService.ShowClinicAreaName = '';
        this.dashboardService.ShowCateName = '';
      }

      // const todaysdate = this.authService.getServerDate;
      // this.dashboardService.selecteddate = this.datePipe.transform(todaysdate, "yyyy-MM-dd");
      this.dashboardService
        .getopdvisit()
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (data) => this.successopdvisit(data),
          (err) => this.failedopdvisit(err)
        );
      //  this.getappointment_details();
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg22"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  sortdata_seq() {
    const sequencecol: any = this.dataSource.data.sort(
      this.compareValues("sequence")
    );
    this.dataSource.data = sequencecol;
  }

  sortdata_seq_desc() {
    const sequencecol: any = this.dataSource.data.sort(
      this.compareValues("sequence", "desc")
    );
    this.dataSource.data = sequencecol;
  }

  sortdata() {
    // const container = this.dataSource.data;
    const ascending: any = this.dataSource.data.sort(
      this.compareValues("patientName")
    );
    this.dataSource.data = ascending;
    // singers.sort(compareValues('band'));
  }
  sortdatarefered() {
    const ascending: any = this.dataSource.data.sort(
      this.compareValues("referredByName")
    );
    this.dataSource.data = ascending;
  }
  sortdatarefdesc() {
    const decending: any = this.dataSource.data.sort(
      this.compareValues("referredByName", "desc")
    );
    this.dataSource.data = decending;
  }
  compareValues(key, order = "asc") {
    //console.log("method called");
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === "desc" ? comparison * -1 : comparison;
    };
  }

  sortdatadesc() {
    const decending: any = this.dataSource.data.sort(
      this.compareValues("patientName", "desc")
    );
    this.dataSource.data = decending;
    //  singers.sort(compareValues('band', 'desc'));
  }

  filterbydate(selecteddate: string) {
    // this.open_loader_Dialog();

    let container = selecteddate.split("/", 3);

    let selecteddate_converted =
      container[1] + "/" + container[0] + "/" + container[2];

    //console.log("date converted " + selecteddate_converted);

    this.dashboardService.selecteddate = this.datePipe.transform(
      selecteddate_converted,
      "yyyy-MM-dd"
    );

    //console.log("after conversion date is " + this.dashboardService.selecteddate);

    // call opd list again based on new date selection
    this.dashboardService
      .getopdvisit()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => this.successopdvisit(data),
        (err) => this.failedopdvisit(err)
      );

    // call appointment details again based on new date selection
    // this.getappointment_details();
  }

  check_totaltime_spent_by_patient(
    visittime: string,
    timespan: string,
    timedisplay1: number,
    timedisplay2: number,
    timedisplay3: number
  ) {
    var diff;
    var days;
    var hours;
    var minutes;
    var seconds;

    let currenttime = this.datePipe.transform(new Date(), "HH:mm:ss");
    let dateofvisit = this.datePipe.transform(
      this.dashboardService.selecteddate,
      "yyyy-MM-dd"
    );
    let currentdate = this.authService.getServerDate;

    getDataDiff(
      new Date(dateofvisit + " " + visittime),
      new Date(currentdate + " " + currenttime)
    );

    function getDataDiff(startDate, endDate) {
      diff = endDate.getTime() - startDate.getTime();
      //console.log(endDate.getTime() + "  " + startDate.getTime());
      days = Math.floor(diff / (60 * 60 * 24 * 1000));
      // //console.log("days" + days)
      hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
      // //console.log("hours" + hours)
      minutes = Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
      //console.log("min" + minutes)
      seconds =
        Math.floor(diff / 1000) -
        (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    }

    //console.log ("total time spent " + hours * 60 + minutes );

    const totalminspent = hours * 60 + minutes;

    if (timespan == "timespan1") {
      if (totalminspent > timedisplay1 && totalminspent < timedisplay2) {
        return totalminspent;
      }
    }
    if (timespan == "timespan2") {
      if (totalminspent > timedisplay2 && totalminspent < timedisplay3) {
        return totalminspent;
      }
    }
    if (timespan == "timespan3") {
      if (totalminspent > timedisplay3) {
        return totalminspent;
      }
    }
  }

  gettimecount(
    timedisplay1: number,
    timedisplay2: number,
    timedisplay3: number,
    timespan: string
  ) {
    if (timedisplay1 == null && timedisplay2 == null && timedisplay3 == null) {
      timedisplay1 = 30;
      timedisplay2 = 60;
      timedisplay3 = 90;
    }
    if (timespan == "timespan1") {
      return this.usertype_opd_visits.filter(
        (patient) =>
          this.check_totaltime_spent_by_patient(
            patient.visitTime,
            timespan,
            timedisplay1,
            timedisplay2,
            timedisplay3
          ) > timedisplay1
      ).length;
    }

    if (timespan == "timespan2") {
      return this.usertype_opd_visits.filter(
        (patient) =>
          this.check_totaltime_spent_by_patient(
            patient.visitTime,
            timespan,
            timedisplay1,
            timedisplay2,
            timedisplay3
          ) > timedisplay2
      ).length;
    }

    if (timespan == "timespan3") {
      return this.usertype_opd_visits.filter(
        (patient) =>
          this.check_totaltime_spent_by_patient(
            patient.visitTime,
            timespan,
            timedisplay1,
            timedisplay2,
            timedisplay3
          ) > timedisplay3
      ).length;
    }
  }

  getRemarkcolor(statusremark: boolean, fullremark: string) {
    if (statusremark == true) {
      return "#1b3465";
    } else if (statusremark == false && fullremark != null) {
      return "#30b8fc";
    } else {
      return "#e6e7e8";
    }
  }

  showonlyfirst10(fullremark: string) {
    if (fullremark == null) {
      return "";
    } else if (String(fullremark).length > 50) {
      return fullremark.length == 0 ? "" : fullremark.substring(0, 50) + "..";
    } else {
      return fullremark.length == 0 ? "" : fullremark;
    }
  }
  showonlyfirstparty(partyName: string) {
    if (partyName == null) {
      return "";
    } else if (String(partyName).length > 18) {
      return partyName.length == 0 ? "" : partyName.substring(0, 18) + "..";
    } else {
      return partyName.length == 0 ? "" : partyName;
    }
  }
  showonlyfirstCD(deptName: string) {
    if (deptName == null) {
      return "";
    } else if (String(deptName).length > 20) {
      return deptName.length == 0 ? "" : deptName.substring(0, 20) + "..";
    } else {
      return deptName.length == 0 ? "" : deptName;
    }
  }
  timefilter(time: number) {
    switch (time) {
      case 90: {
        this.time_usertype_visits = this.usertype_opd_visits.filter(
          (patient) => +patient.totalTime > time
        );

        break;
      }
      case 60: {
        this.time_usertype_visits = this.usertype_opd_visits.filter(
          (patient) => +patient.totalTime > time
        );
        break;
      }
      case 30: {
        this.time_usertype_visits = this.usertype_opd_visits.filter(
          (patient) => +patient.totalTime > time
        );
        break;
      }
    }
    this.dataSource.data = this.time_usertype_visits;
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    // this.dataSource.filter = null;
    this.searchstring = "";
  }
  gettotalcount() {
    // return this.dataSource.data.length;
    return this.opd_visits.length;
  }

  checkrecords() {
    if (this.opd_visits.length == 0) return true;
  }


  refresh_opd_visits() {
    this.dashboardService.selecteddate = this.datePipe.transform(
      this.dashboardService.todaysdate,
      "yyyy-MM-dd"
    );
    // this.open_loader_Dialog()
    this.dashboardService
      .getopdvisit()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => this.successopdvisit(data),
        (err) => this.failedopdvisit(err)
      );
    // this.getappointment_details();
  }

  // openloaderDialoge(){
  //   this.open_loader_Dialog();
  //    setInterval(() => {
  //     this.dialog.closeAll();
  //     }, 2000);
  // }

  // colorremark(remarkcheck: any) {

  //   if (remarkcheck != null && remarkcheck != "") {
  //     return 'Yellow';
  //   } else {
  //     return null;
  //   }
  // }
  getagecolor(age: number) {
    if (
      this.dashboardService.maxAgeColorCode &&
      this.dashboardService.minAgeColorCode
    ) {
      if (
        age <= this.dashboardService.minAgeColorCode ||
        age >= this.dashboardService.maxAgeColorCode
      ) {
        return "#EE7336";
      }
    } else {
      if (age <= 2 || age >= 80) {
        return "#EE7336";
      }
    }
  }
  setage(year: number, months: number, days: number) {
    if (year > 0) {
      return year + "(Y)";
    } else if (months > 0) {
      return months + "(M)";
    } else {
      return days + "(D)";
    }
  }
  gettforinfantorolder(years: number) {
    if (years <= 2) {
      return "This patient is infant";
    } else if (years >= 80) {
      return "This patient is older than 80 years";
    }
  }

  checkstatus(value: number) {
    if (value > 0) {
      return this.authService.validationMsg["dashboardValidMsg.msg41"];
    } else {
      return this.authService.validationMsg["dashboardValidMsg.msg42"];
    }
  }

  // Document Upload Count
  docCount(value) {
    if (value == null) {
      return "0";
    } else {
      return value;
    }
  }

  chkvip(isvip: boolean, vipname: string) {
    if (isvip == true) {
      return "Vip:" + vipname;
    } else {
      return "Vip: Not found";
    }
  }

  chk_Fresh_Review(status: boolean) {
    if (status == true) {
      return "R";
    } else {
      return "F";
    }
  }
  tt_fresh_review(status: boolean) {
    if (status == true) {
      return "Review";
    } else {
      return "Fresh";
    }
  }
  get_apt_color(checkmult: boolean) {
    if (checkmult == true) {
      return "#30b8fc";
    } else {
      return "";
    }

    // if (apptime == null) {
    // }
    // else if (apptime != "") {
    //   let d1 = new Date(appDate);
    //   let d2 = new Date(this.authService.getServerDate);
    //   var month = d1.getUTCMonth() + 1;
    //   var day = d1.getDate();
    //   var year = d1.getUTCFullYear();
    //   var month1 = d2.getUTCMonth() + 1;
    //   var day1 = d2.getDate();
    //   var year1 = d2.getUTCFullYear();
    //   let appdate = day + "/" + month + "/" + year;
    //   let todaysdate = day1 + "/" + month1 + "/" + year1;

    //   if (appdate == todaysdate) {
    //     return "#FC42F0";
    //   }
    //   else {
    //     return "#145811";
    //   }

    // }
  }

  getdoccolor(emrflag: any) {
    if (emrflag != 0) {
      return "#24ad1d";
    }
  }
  getemrcolor(emrflag: boolean) {
    if (emrflag == true) {
      return "#24ad1d";
    }
  }
  getemrtextcolor(emrflag: boolean) {
    if (emrflag == true) {
      return "#F7F9F9";
    }
  }

  getpatient_name_by_formula(
    patientName: string,
    firstName: string,
    lastName: string,
    careofType: string,
    initial: string,
    fathername: string,
    display: string
  ) {
    if (careofType == null) {
      careofType = "";
    }
    if (initial == null) {
      initial = "";
    }
    if (fathername == null) {
      fathername = "";
    }
    if (lastName == null) {
      lastName = "";
    }

    let patterid = this.authService.Loggeduser.patientname_formula_id;
    //console.log("pattern " + this.authService.Loggeduser.patientname_formula_id)

    if (patientName == null) {
      return "";
    } else {
      if (patterid == 1) {
        if (display == "tooltip") {
          return (firstName + " " + lastName).trim();
        } else {
          if ((firstName + " " + lastName).length > 22) {
            return (firstName + " " + lastName).substring(0, 22).trim() + "..";
          } else {
            return (firstName + " " + lastName).trim();
          }
        }
      } else if (patterid == 2) {
        if (display == "tooltip") {
          return (
            firstName +
            " " +
            lastName +
            " " +
            careofType +
            " " +
            fathername
          ).trim();
        } else {
          if (
            (firstName + " " + lastName + " " + careofType + " " + fathername)
              .length > 30
          ) {
            return (
              (firstName + " " + lastName + " " + careofType + " " + fathername)
                .substring(0, 30)
                .trim() + ".."
            );
          } else {
            return (
              firstName +
              " " +
              lastName +
              " " +
              careofType +
              " " +
              fathername
            ).trim();
          }
        }
      } else if (patterid == 3) {
        if (display == "tooltip") {
          return (
            initial +
            " " +
            firstName +
            " " +
            lastName +
            " " +
            careofType +
            " " +
            fathername
          ).trim();
        } else {
          if (
            (
              initial +
              " " +
              firstName +
              " " +
              lastName +
              " " +
              careofType +
              " " +
              fathername
            ).length > 30
          ) {
            return (
              (
                initial +
                " " +
                firstName +
                " " +
                lastName +
                " " +
                careofType +
                " " +
                fathername
              )
                .trim()
                .substring(0, 22) + ".."
            );
          } else {
            return (
              initial +
              " " +
              firstName +
              " " +
              lastName +
              " " +
              careofType +
              " " +
              fathername
            ).trim();
          }
        }
      } else if (patterid == 4) {
        if (display == "tooltip") {
          return (firstName + " " + lastName + " " + fathername).trim();
        } else {
          if ((firstName + " " + lastName + " " + fathername).length > 22) {
            return (
              (firstName + " " + lastName + " " + fathername)
                .substring(0, 22)
                .trim() + ".."
            );
          } else {
            return (firstName + " " + lastName + " " + fathername).trim();
          }
        }
      } else {
        if (lastName == null) {
          return (firstName + " " + "").trim();
        } else {
          return (firstName + " " + lastName).trim();
        }
      }
    }
  }

  formatreturntime(returntime: string) {
    // //console.log("Return time " + returntime);
    if (returntime == null) {
      // do nothing
      //09:30:00.000000
      return "Not Provided";
    } else {
      // "12:10:00.0000000"
      var hr_min = returntime.split(":", 3);
      // var hr_min = hr_min_sec[0].split(":",3);
      // return hr_min[0] + ":" + hr_min[1];

      if (+hr_min[0] == 12 && +hr_min[1] == 0o0) {
        return hr_min[0] + ":" + "00" + " pm";
      } else if (+hr_min[0] < 12) {
        return hr_min[0] + ":" + hr_min[1] + " am";
      } else {
        if (+hr_min[0] == 12) {
          return +hr_min[0] + ":" + hr_min[1] + " pm";
        } else if (+hr_min[0] - 12 <= 9) {
          return "0" + (+hr_min[0] - 12) + ":" + hr_min[1] + " pm";
        } else {
          return +hr_min[0] - 12 + ":" + hr_min[1] + " pm";
        }
      }
    }
  }
  // remove second in appointment time and reporting time
  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
  formattime(appttime: string) {
    if (appttime == null) {
      // do nothing
      //09:30:00.000000
    } else {
      // "12:10:00.0000000"
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      // return hr_min[0] + ":" + hr_min[1];

      if (+hr_min[0] == 12 && +hr_min[1] == 0o0) {
        // //console.log ("app time " + hr_min[0]);
        return hr_min[0] + ":" + "00" + " pm";
      } else if (+hr_min[0] < 12) {
        return hr_min[0] + ":" + hr_min[1] + " am";
      } else {
        if (+hr_min[0] == 12) {
          return +hr_min[0] + ":" + hr_min[1] + " pm";
        } else if (+hr_min[0] - 12 <= 9) {
          return "0" + (+hr_min[0] - 12) + ":" + hr_min[1] + " pm";
        } else {
          return +hr_min[0] - 12 + ":" + hr_min[1] + " pm";
        }
      }
    }
  }

  getbordercolor(boxnumber: number) {
    switch (boxnumber) {
      case 1: {
        return "#4E77F6";
      }
      case 2: {
        return "#015C14";
      }
      case 3: {
        return "#CB8133";
      }
      case 4: {
        return "#D43F4B";
      }
    }
  }

  gettopbackcolor(boxnumber: number) {
    switch (boxnumber) {
      case 1: {
        return "#B2E4FA";
        break;
      }
      case 2: {
        return "#0CFC3F";
        break;
      }
      case 3: {
        return "#F4D1AC";
        break;
      }
      case 4: {
        return "#F5A0A7";
        break;
      }
    }
  }

  getbottombackcolor(boxnumber: number) {
    switch (boxnumber) {
      case 1: {
        return "#0E8EF9";
      }
      case 2: {
        return "#015C14";
      }
      case 3: {
        return "#CB8133";
      }
      case 4: {
        return "#D43F4B";
      }
    }
  }
  getboxfrontcolor() {
    return "#010508";
  }
  getdilationcolor(isdilation: number, finishTime: any) {
    const newtime = this.datePipe.transform(new Date(), "HH:mm:ss")
    const currentTimeDate = new Date(`1970-01-01T${newtime}`);
    const finishTimeDate = new Date(`1970-01-01T${finishTime}`);
    switch (isdilation) {
      case 0: {
        this.dilationTittle =
          this.authService.validationMsg["dashboardValidMsg.msg38"];
        break;
      }
      //dialation sta rts
      case 1: {
        if (currentTimeDate > finishTimeDate) {
          this.authService.validationMsg["dashboardValidMsg.msg39"];
          return "#ff0000";
        } else {
          this.dilationTittle =
            this.authService.validationMsg["dashboardValidMsg.msg39"];
          return "#fff700";
        }

        break;
      }
      //dilation finished
      case 2: {
        this.dilationTittle =
          this.authService.validationMsg["dashboardValidMsg.msg40"];
        return "#22A708";
        break;
      }
    }
  }
  getdilationtt(isdilation: number, dilationwith: string, dilatedby: number) {

    switch (isdilation) {
      //dilation not started yet or removed
      case 0: {
        return "Click here to start dilation";
        break;
      }
      //dialation starts
      case 1: {
        return (
          "Dilation started with" +
          dilationwith +
          ",Created By " +
          dilatedby
        );
        break;
      }
      //dilation finished
      case 2: {
        return (
          "Dilation finished with" +
          dilationwith +
          ",Created By " +
          dilatedby
        );
        break;
      }
    }
  }
  getcategory_color(catid: number) {
    var catcolorrow = this.dashboardService.categories.find(
      (item) => item.pkCategoryId == catid
    );
    if (catcolorrow == undefined) {
      let webcolor = "red";
      return webcolor;
    } else {
      return catcolorrow.webColor;
    }

    //console.log("catcolor" + catcolorrow.webColor);
  }
  getdefaultrow_selected() {
    return this.authService.Loggeduser.dashboardrows;
  }

  gettimecolor(timename: string) {
    if (timename == "time1") {
      return "#F0E68C";
    } else if (timename == "time2") {
      return "#FFD700";
    } else {
      return "#FFFF00";
    }
  }

  getTotaltime(rpttime: string, locationid: number, returntime: string) {
    var diff;
    var days;
    var hours;
    var minutes;
    var seconds;

    let currenttime = this.datePipe.transform(new Date(), "HH:mm:ss");
    let dateofvisit = this.datePipe.transform(
      this.dashboardService.selecteddate,
      "yyyy-MM-dd"
    );
    let currentdate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");

    if (locationid == 10) {
      returnTimeDiff(
        new Date(dateofvisit + " " + rpttime),
        new Date(currentdate + " " + returntime)
      );
    } else {
      getDataDiff(
        new Date(dateofvisit + " " + rpttime),
        new Date(currentdate + " " + currenttime)
      );
      // //console.log("date of visit" + dateofvisit);
      // //console.log("current time " + currenttime);
    }

    function getDataDiff(startDate, endDate) {
      diff = endDate.getTime() - startDate.getTime();
      if (diff < 0) {
        days = 0;
        hours = 0;
        minutes = 0;
        seconds = 0;
        return
      }
      //console.log(endDate.getTime() + "  " + startDate.getTime());
      days = Math.floor(diff / (60 * 60 * 24 * 1000));
      // //console.log("days" + days)
      hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
      // //console.log("hours" + hours)
      minutes = Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
      //console.log("min" + minutes)
      seconds =
        Math.floor(diff / 1000) -
        (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
      // //console.log("sec" + seconds)
      // //console.log ("visit id "+ visitid)
    }

    function returnTimeDiff(startDate, endDate) {
      diff = endDate.getTime() - startDate.getTime();
      days = Math.floor(diff / (60 * 60 * 24 * 1000));
      hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
      minutes = Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
      seconds =
        Math.floor(diff / 1000) -
        (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    }
    //return { day: days, hour: hours, minute: minutes, second: seconds };
    //return (hours -12) + ":" + minutes + ":" + seconds

    if (hours <= 9 && minutes <= 9) {
      return "0" + hours + ":" + "0" + minutes;
    } else if (hours <= 9 && minutes > 9) {
      return "0" + hours + ":" + minutes;
    } else if (hours > 9 && minutes <= 9) {
      return hours + ":" + "0" + minutes;
    } else {
      return hours + ":" + minutes;
    }

    //console.log( hours + ":" + minutes + ":" + seconds);
  }
  getTotaltimecolor(
    rpttime: string,
    locationid: number,
    returntotal_time: string
  ) {
    var diff;
    var days;
    var hours;
    var minutes;
    var seconds;

    if (locationid == 10) {
      return returntotal_time;
    } else {
      let currenttime = this.datePipe.transform(new Date(), "HH:mm:ss");
      let dateofvisit = this.datePipe.transform(
        this.dashboardService.selecteddate,
        "yyyy-MM-dd"
      );
      let currentdate = this.authService.getServerDate;

      getDataDiff(
        new Date(dateofvisit + " " + rpttime),
        new Date(currentdate + " " + currenttime)
      );
      function getDataDiff(startDate, endDate) {
        diff = endDate.getTime() - startDate.getTime();
        if (diff < 0) {
          days = 0;
          hours = 0;
          minutes = 0;
          seconds = 0;
          return
        }
        //console.log(endDate.getTime() + "  " + startDate.getTime());
        days = Math.floor(diff / (60 * 60 * 24 * 1000));
        // //console.log("days" + days)
        hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
        // //console.log("hours" + hours)
        minutes =
          Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
        //console.log("min" + minutes)
        seconds =
          Math.floor(diff / 1000) -
          (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
        // //console.log("sec" + seconds)
        // //console.log ("visit id "+ visitid)
      }
      const totalminspent = hours * 60 + minutes;
      if (totalminspent >= 30 && totalminspent <= 60) {
        const tcolor = this.dashboardService.timeslots[0]?.timeIntervalAColor;
        return "#" + tcolor;
      } else if (totalminspent > 60 && totalminspent <= 90) {
        const tcolor = this.dashboardService.timeslots[0]?.timeIntervalBColor;

        return "#" + tcolor;
      } else if (totalminspent > 90) {
        var tcolor = this.dashboardService.timeslots[0]?.timeIntervalCColor;
        if (tcolor == "ff") {
          tcolor = "ff0000";
        }
        return "#" + tcolor;
      } else {
        const tcolor = "";
        return tcolor;
      }
    }
  }

  getfreshcount() {
    // this.usertype_opd_visits.filter(patient => patient.isReview === false);
    let freshFilter = this.usertype_opd_visits.filter(
      (patient) => patient.isReview === false
    );
    if (freshFilter.length !== 0) {
      this.dataSource.data = freshFilter;
      this.pageLoad();
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg23"],
        this.authService.validationMsg["Ok"]
      );
    }
  }
  getreviewcount() {
    // return this.usertype_opd_visits.filter(patient => patient.isReview === true).length;
    let reviewFilter = this.usertype_opd_visits.filter(
      (patient) => patient.isReview === true
    );
    if (reviewFilter.length !== 0) {
      this.dataSource.data = reviewFilter;
      this.pageLoad();
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg23"],
        this.authService.validationMsg["Ok"]
      );
    }
  }
  getdialationcount() {
    // return this.usertype_opd_visits.filter(patient => patient.isDilated === 1).length;
    let dilationFilter = this.usertype_opd_visits.filter(
      (patient) => patient.isDilated !== 0
    );
    if (dilationFilter.length !== 0) {
      this.dataSource.data = dilationFilter;
      this.pageLoad();
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg23"],
        this.authService.validationMsg["Ok"]
      );
    }
  }
  pageLoad() {
    this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    // this.dataSource.filter = null;
    this.searchstring = "";
  }

  getClass(locid: any) {
    switch (locid) {
      case 1: {
        return "user-doctor";
        break;
      }
      case 3: {
        return "briefcase";
        break;
      }
      case 4: {
        return "refraction";
        break;
      }
      case 5: {
        return "optometrist";
        break;
      }
      case 7: {
        return "user-doctor";
        break;
      }
      case 9: {
        return "hourglass";
        break;
      }
      case 10: {
        return "arrow-rotate";
        break;
      }
      case 21: {
        return "file-medical";
        break;
      }
    }
  }
  // keyDownFunction(event) {
  //     debugger
  //   if (event.keyCode === 27) {
  //     document.getElementById("PatientDetailModel").style.display = "block";
  //     }

  // }

  userControll() {

    this.userCtrl = new FormControl();
    this.megyek = of(this.locationsubfilterlist);
    this.filteredUserArray = this.userCtrl.valueChanges.pipe(
      startWith(""),
      switchMap((value) => this._filter(value))
    );
    if (
      this.authService.Loggeduser.usertypeid != 9 && !this.authService.checkfirsttimeload
    ) {

      this.selectedusername = this.locationsubfilterlist.filter(item => item.userId == this.authService.Loggeduser.userid)[0]?.userName;
      this.dashboardService.selecteduser = this.locationsubfilterlist.filter(item => item.userId == this.authService.Loggeduser.userid)[0]?.userName;
      this.userCtrl.setValue(this.selectedusername);

      // setTimeout(()=>{

      // },500)
    } else {
      if (this.dashboardService.selecteduser) {
        this.userCtrl.setValue(this.dashboardService.selecteduser);

      } else {
        this.selectedusername = "ALL";
      }

    }
    this.authService.checkfirsttimeload = false;
  }
  private _filter(value: string): Observable<string[]> {
    return this.megyek.pipe(
      map((options) =>
        options.filter((option) =>
          option.userName.toLowerCase().includes(value)
        )
      )
    );
  }
  // filterUserFunction(name: string) {
  //   return this.locationsubfilterlist.filter(item =>
  //     item.userName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  // }

  userSearch(event) {
    let allUserList = event.target.value;
    //  this.selectedusername =allUserList;
    if (allUserList == "") {
      allUserList = "ALL";
      this.userfilter(allUserList);
    }
  }

  filterOptions() {
    if (this.authService.DynamicLinks.productType == "LIVE") {
      document.getElementById("filterOptionsModal").style.display = "none";
    } else {
      document.getElementById("filterOptionsModal").style.display = "block";
    }
  }
  cancelfilterOptions() {
    document.getElementById("filterOptionsModal").style.display = "none";
  }

  visible: boolean = false;
  gridView = true;
  gridToggle() {
    // console.log(this.gridView);
    this.gridView = !this.gridView;
    this.visible = !this.visible;
    if (!this.gridView) {
      this.loadAllLocation();
    }
  }
  // liveTimer() {
  //   setInterval(() => {
  //     this.today = Date.now();
  //   }, 1000);
  // }
  locationFilter(event, data) {
    // this.headerFillter = data;
    // this.filterbyLoc(data);
  }
  filterbyLoc(data) {
    let locid = data;
    switch (locid) {
      // Reception
      case 1: {
        // this.locationName = '';
        break;
      }
      case 3: {
        // Clinical Department
        this.locationName = "CD(S)";
        break;
      }
      case 4: {
        // Auto Refraction
        this.locationName = "AR(S)";
        break;
      }
      case 5: {
        this.locationName = "OP(S)";
        break;
      }
      case 6: {
        this.locationName = "DOCTOR(S)";
        break;
      }
      case 7: {
        this.locationName = "CS(S)";
        break;
      }
      case 8: {
        this.locationName = "PR(S)";
        break;
      }
      case 21: {
        this.locationName = "PHY(S)";
        break;
      }
    }
  }

  drop(event: CdkDragDrop<string[]>, id: any) {
    let selectedPat = event.item.data;
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      let usertypeId = Number(event.container.id);
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      if (this.usertypeIdmove == 1) {
        this.move_patient_reception(
          this.patdetails.pK_VisitId,
          this.patdetails.fK_PatientLocationId
        );
      } else if (this.usertypeIdmove == 10) {
        this.return_patient(
          this.patdetails.pK_VisitId,
          this.patdetails.fK_PatientLocationId
        );
      } else if (this.usertypeIdmove == 9) {
        this.move_patient_waiting(
          this.patdetails.pK_VisitId,
          this.patdetails.fK_PatientLocationId
        );
      }
    }

    document.getElementById(this.locationName).style.visibility = "hidden";
  }

  dragStarted(event: CdkDragStart) {
    console.log("dragStarted Event > item", event.source.data);
  }

  dragEnded(event: CdkDragEnd) {
    console.log("dragEnded Event > item", event.source.data);
    this.patdetails = event.source.data;
  }

  dragEntered(event: CdkDragEnter) {
    if (this.authService.masterdata.isPatientTransfer == true) {
      if (this.locationName != undefined) {
        document.getElementById(this.locationName).style.visibility = "hidden";
      }
      this.usertypeIdmove = Number(event.container.id);
      // this.get_usertype_list(this.usertypeIdmove);
      this.filterbyLoc(this.usertypeIdmove);
      document.getElementById(this.locationName).style.visibility = "visible";
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg24"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  dragExited(event: CdkDragExit) {
    console.log(
      "dragExited Event",
      `> drag '${event.item.data}' from '${event.container.id}'`
    );
  }

  moveUserLocation(event, prelocationid) {
    this.dashboardService.subscriptions = this.dashboardService
      .getlocationType(
        this.patdetails.pK_VisitId,
        prelocationid.userId,
        this.userLocTypeid,
        this.authService.Loggeduser.branchid,
        this.patdetails.fK_PatientLocationId,
        this.userLocTypeid,
        prelocationid.shortName
      )
      // this.http.put<any>(this.dashboardService.newbaseUrl + "VisitMaster/UpdateLocation/" +
      //   this.patdetails.pK_VisitId + "/" + prelocationid.userId + "/" +
      //   this.userLocTypeid + "/" +
      //   this.authService.Loggeduser.branchid + "/" + this.patdetails.fK_PatientLocationId + "/" + this.userLocTypeid
      //   + "/" + prelocationid.shortName, [])
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => this.success_user_moved(data),
        (err) => this.failed_user_moved(err)
      );
  }
  success_user_moved(data) {
    document.getElementById(this.locationName).style.visibility = "hidden";
    this.closetrasnferdata();
    this.dashboardService.openSnackBar(
      this.authService.validationMsg["dashboardValidMsg.msg17"],
      this.authService.validationMsg["Ok"]
    );
    this.refresh_opd_visits();
  }
  failed_user_moved(err) {
    document.getElementById(this.locationName).style.visibility = "hidden";
    this.closetrasnferdata();
    this.dashboardService.openSnackBar(
      this.authService.validationMsg["dashboardValidMsg.msg25"],
      this.authService.validationMsg["Ok"]
    );
    this.refresh_opd_visits();
  }
  onDrop(event: CdkDragDrop<string[]>) {
    let selectedPat = event.item.data;
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      this.userLocTypeid = event.container.id;
      let usertypeId = [];
      usertypeId.push(event.container.data);
      transferArrayItem(
        event.previousContainer.data,
        usertypeId,
        event.previousIndex,
        event.currentIndex
      );
      this.moveUserLocation(event, usertypeId[1]);
    }
  }
  loadAllLocation() {
    this.getCds();
    this.getArs();
    this.getOps();
    this.getDoc();
    this.getAllCss();
    this.getAllPrs();
    this.getPhy();
  }
  getCds() {
    this.dashboardService
      .getall_cds()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.cds = data;
      });
  }
  getArs() {
    this.dashboardService
      .getall_ars()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.ars = data;
      });
  }
  getOps() {
    this.dashboardService
      .getall_ops()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.ops = data;
      });
  }

  getDoc() {
    this.dashboardService
      .getall_doctors()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.allDoc = data;
      });
  }

  getAllCss() {
    this.dashboardService
      .getall_css()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.allCss = data;
      });
  }
  getAllPrs() {
    this.dashboardService
      .getall_prs()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.allPrs = data;
      });
  }
  getPhy() {
    this.dashboardService
      .getall_physicians()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.pyslist = data;
      });
  }
  openBillingData(regid) {
    this.opdvisitService
      .getlastvisit(regid)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((item) => {
        if (item.pK_BillId > 0) {
          const dialogRef = this.dialog.open(BillingComponent, {
            panelClass: "billing-dialog",
            maxWidth: "100vw !important",
            height: "100%",
            width: "100%",
            data: {
              checkvisit: 1,
              lastbillId: item.pK_BillId,
              showheader: true,
            },
            disableClose: true,
          });

          dialogRef
            .afterClosed()
            .pipe(takeUntil(this.destroydashboard$))
            .subscribe((result) => {
              // this.ngOnInit();
            });
        } else {
          this.dashboardService.openSnackBar(
            this.authService.validationMsg["dashboardValidMsg.msg26"],
            this.authService.validationMsg["Ok"]
          );
        }
      });
    // this.route.navigate(['/layout/Billing']);
  }

  //Patient Details Chart Modal
  patientDetailsChartModal() {
    document.getElementById("patientDetailsChartModal").style.display = "block";
  }
  cancelPatientDetailsChartModal() {
    document.getElementById("patientDetailsChartModal").style.display = "none";
  }

  //Call Center Modal
  selectSearchType: string;
  callCenterManagerModal() {
    this.ClearCallCenter(0);
    this.getopdvistColor();
    document.getElementById("callCenterManagerModal").style.display = "block";
  }
  cancelCallCenterManagerModal() {
    this.ClearCallCenter(0);
    document.getElementById("callCenterManagerModal").style.display = "none";
  }

  //Appt Details Chart Modal
  apptDetailsChartModal() {
    this.getappointment_details();
    setTimeout(() => {

      this.doughnutChartData = [
        {
          data: [this.dashboardService.total_appointment_count, 0, 0, 0],
          borderWidth: 0,
          weight: 8,
        },
        { data: [null, null, null, null], borderWidth: 0, weight: 1 },
        {
          data: [
            null,
            this.dashboardService.booked_appointment_count,
            this.dashboardService.pending_appointment_count,
            this.dashboardService.canceled_appointment_count,
          ],
          borderWidth: 0,
          weight: 10,
        },
      ];
      // <<<---using ()=> syntax
      document.getElementById("apptDetailsChartModal").style.display = "block";
    }, 500);

  }
  cancelApptDetailsChartModal() {
    document.getElementById("apptDetailsChartModal").style.display = "none";
  }

  //Appt Details Chart Modal
  patientInformationModal() {
    this.clearPatientInfo();
    document.getElementById("patientInformationModal").style.display = "block";
    this.refreshdoc_list();
  }
  cancelPatientInformationModal() {
    this.clearPatientInfo();
    document.getElementById("patientInformationModal").style.display = "none";
  }
  //priscription print
  prescriptionSetting: any = [];
  PrintList: any = [];
  getpreSetting(bachid, userid, data, type) {

    if (this.opdvisitService.patientdetails.pkRegId) {
      if (this.opdvisitService.visitdates.length > 0) {
        this.emrservice
          .GetPreSetting(bachid, userid, data)
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe((item) => {

            this.prescriptionSetting = [];
            this.PrintList = [];
            this.prescriptionSetting = item;

            this.PrintList = this.prescriptionSetting.filter(
              (x) => !x.colName.startsWith("Clear")
            );
            if (this.prescriptionSetting.length == 0) {
              this.emrservice
                .GetPreSetting(1, 1, data)
                .pipe(takeUntil(this.destroydashboard$))
                .subscribe(
                  (item) => {

                    this.prescriptionSetting = [];
                    this.PrintList = [];
                    this.prescriptionSetting = item;

                    this.PrintList = this.prescriptionSetting.filter(
                      (x) => !x.colName.startsWith("Clear")
                    );
                    this.getprintReport_url(
                      this.opdvisitService.patientdetails.pkRegId,
                      type
                    );
                  },
                  (err) => {
                    if (err.status == 403) {
                      this.dashboardService.openSnackBar(
                        "You Don't have Permission",
                        "OK"
                      );
                    } else {
                      this.dashboardService.openSnackBar("API Failed", "OK");
                    }
                  }
                );
            } else {
              this.getprintReport_url(
                this.opdvisitService.patientdetails.pkRegId,
                type
              );
            }
          });
      } else {
        this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg27"],
          this.authService.validationMsg["Ok"]
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg28"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  getprintReport_url(patientid: number, type) {

    if (patientid > 0 && type == 0) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Prescription" && item.printType == "NetramReport"
      );
      if (checkreporttype.length > 0) {
        this.dashboardService
          .getsummary_url()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.succesurldata(data, patientid, type),
            (err) => this.failedurldata(err)
          );
      } else {
        this.printTimelineBill('Prescription', patientid);
      }
    } else if (type == 1) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Medical Prescription" &&
          item.printType == "WebNetramReport"
      );
      if (checkreporttype.length > 0) {
        this.printTimelineBill('Medical Prescription', patientid);
      } else {
        this.dashboardService
          .getsummary_url()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.succesurldata(data, patientid, type),
            (err) => this.failedurldata(err)
          );
      }

    } else if (type == 2) {
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "DailyCaseSheet" &&
          item.printType == "WebNetramReport"
      );
      if (checkreporttype.length > 0) {
        this.printTimelineBill('DailyCaseSheet', patientid);
      } else {
        this.dashboardService
          .getsummary_url()
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (data) => this.succesurll(data, patientid, type),
            (err) => this.failedurl(err)
          );
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg28"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  PrescriptionMedicine: any;
  PageHeader: any;
  reporturl: any;
  succesurldata(data, patientid, type) {
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      if (element.propertyName === "PrescriptionMedicinePattern") {
        this.PrescriptionMedicine = element;
      }

      if (element.propertyName === "PageHeadWebReport") {
        this.PageHeader = element;
      }

      if (element.propertyName === "WebURL") {
        this.reporturl = element.propertyValue;
      }
    }

    let vDate = this.datePipe.transform(
      this.emrservice.visitDate,
      "dd-MMM-yyyy"
    );
    if (type == 0) {
      window.open(
        this.reporturl +
        "Prescription.aspx?PrescriptionMedicinePattern=" +
        this.PrescriptionMedicine.propertyValue +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&RegID=" +
        patientid +
        "&AgeDesc=" +
        this.opdvisitService.printpriciptionAge +
        "&VisitID=" +
        this.emrservice.visitid +
        "&VisitDate=" +
        vDate +
        "&ExamID=" +
        this.emrservice.examid +
        "&DoctorId=" +
        this.opdvisitService.DoctorIdEmr +
        "&" +
        this.PrintList[0].colName +
        "=" +
        (this.PrintList[0].colValue == true ? "Y" : "N") +
        "&PageHeadWebReport=" +
        (this.PrintList[13].colValue == true ? "Y" : "N") +
        "&PrintOPDTest=" +
        (this.PrintList[15].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[1].colName +
        "=" +
        (this.PrintList[1].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[2].colName +
        "=" +
        (this.PrintList[2].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[3].colName +
        "=" +
        (this.PrintList[3].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[4].colName +
        "=" +
        (this.PrintList[4].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[5].colName +
        "=" +
        (this.PrintList[5].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[6].colName +
        "=" +
        (this.PrintList[6].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[7].colName +
        "=" +
        (this.PrintList[7].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[8].colName +
        "=" +
        (this.PrintList[8].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[9].colName +
        "=" +
        (this.PrintList[9].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[10].colName +
        "=" +
        (this.PrintList[10].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[11].colName +
        "=" +
        (this.PrintList[11].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[12].colName +
        "=" +
        (this.PrintList[12].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[13].colName +
        "=" +
        (this.PrintList[13].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[14].colName +
        "=" +
        (this.PrintList[14].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[15].colName +
        "=" +
        (this.PrintList[15].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[16].colName +
        "=" +
        (this.PrintList[16].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[17].colName +
        "=" +
        (this.PrintList[17].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[18].colName +
        "=" +
        (this.PrintList[18].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[19].colName +
        "=" +
        (this.PrintList[19].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[20].colName +
        "=" +
        (this.PrintList[20].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[21].colName +
        "=" +
        (this.PrintList[21].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[22].colName +
        "=" +
        (this.PrintList[22].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[23].colName +
        "=" +
        (this.PrintList[23].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[24].colName +
        "=" +
        (this.PrintList[24].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[25].colName +
        "=" +
        (this.PrintList[25].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[26].colName +
        "=" +
        (this.PrintList[26].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[27].colName +
        "=" +
        (this.PrintList[27].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[28].colName +
        "=" +
        (this.PrintList[28].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[29].colName +
        "=" +
        (this.PrintList[29].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[30].colName +
        "=" +
        (this.PrintList[30].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[31].colName +
        "=" +
        (this.PrintList[31].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[32].colName +
        "=" +
        (this.PrintList[32].colValue == true ? "Y" : "N") +
        "&UserTypeId=" +
        this.authService.Loggeduser.usertypeid +
        "&LanguageId=" +
        1 +
        "&ReportHeading=Prescription"
      );
    } else {
      window.open(
        this.reporturl +
        "MedicinePrescriptionOnly.aspx?PrescriptionMedicinePattern=" +
        this.PrescriptionMedicine.propertyValue +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&RegID=" +
        patientid +
        "&AgeDesc=" +
        this.opdvisitService.printpriciptionAge +
        "&VisitID=" +
        this.emrservice.visitid +
        "&VisitDate=" +
        vDate +
        "&ExamID=" +
        this.emrservice.examid +
        "&DoctorId=" +
        this.opdvisitService.DoctorIdEmr +
        "&" +
        this.PrintList[0].colName +
        "=" +
        (this.PrintList[0].colValue == true ? "Y" : "N") +
        "&PageHeadWebReport=" +
        (this.PrintList[13].colValue == true ? "Y" : "N") +
        "&PrintOPDTest=" +
        (this.PrintList[15].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[1].colName +
        "=" +
        (this.PrintList[1].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[2].colName +
        "=" +
        (this.PrintList[2].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[3].colName +
        "=" +
        (this.PrintList[3].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[4].colName +
        "=" +
        (this.PrintList[4].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[5].colName +
        "=" +
        (this.PrintList[5].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[6].colName +
        "=" +
        (this.PrintList[6].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[7].colName +
        "=" +
        (this.PrintList[7].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[8].colName +
        "=" +
        (this.PrintList[8].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[9].colName +
        "=" +
        (this.PrintList[9].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[10].colName +
        "=" +
        (this.PrintList[10].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[11].colName +
        "=" +
        (this.PrintList[11].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[12].colName +
        "=" +
        (this.PrintList[12].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[13].colName +
        "=" +
        (this.PrintList[13].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[14].colName +
        "=" +
        (this.PrintList[14].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[15].colName +
        "=" +
        (this.PrintList[15].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[16].colName +
        "=" +
        (this.PrintList[16].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[17].colName +
        "=" +
        (this.PrintList[17].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[18].colName +
        "=" +
        (this.PrintList[18].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[19].colName +
        "=" +
        (this.PrintList[19].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[20].colName +
        "=" +
        (this.PrintList[20].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[21].colName +
        "=" +
        (this.PrintList[21].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[22].colName +
        "=" +
        (this.PrintList[22].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[23].colName +
        "=" +
        (this.PrintList[23].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[24].colName +
        "=" +
        (this.PrintList[24].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[25].colName +
        "=" +
        (this.PrintList[25].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[26].colName +
        "=" +
        (this.PrintList[26].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[27].colName +
        "=" +
        (this.PrintList[27].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[28].colName +
        "=" +
        (this.PrintList[28].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[29].colName +
        "=" +
        (this.PrintList[29].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[30].colName +
        "=" +
        (this.PrintList[30].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[31].colName +
        "=" +
        (this.PrintList[31].colValue == true ? "Y" : "N") +
        "&" +
        this.PrintList[32].colName +
        "=" +
        (this.PrintList[32].colValue == true ? "Y" : "N") +
        "&UserTypeId=" +
        this.authService.Loggeduser.usertypeid +
        "&LanguageId=" +
        1 +
        "&ReportHeading=Prescription"
      );
    }
  }
  failedurldata(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  printTimelineBill(type, regid) {

    let payload = {
      WebReportPrintMaster: {
        module: "Doctor",
        // "printOption": "Prescription",
        printOption: type,
        printType: "WebNetramReport",
        PRINTDATE: this.datePipe.transform(
          this.authService.localDate,
          "dd/MM/yyyy"
        ),
        PrintTime: this.dashboardService.convertTime12Hour(new Date()),
        Pk_RegId: regid,
        BILLINGCOMPANYNAME: this.authService.Loggeduser.billingcompanyname,
        PRINTCONFIGURATIONARRAY:
          type == 'Prescription' || 'DailyCaseSheet' ? JSON.stringify(this.PrintList) : "N",
        Pk_VisitId: type == 'Medical Record' ? 0 : this.emrservice.visitid,
        Pk_ExamId: type == 'Medical Record' ? 0 : this.emrservice.examid,
        VISITDATE: this.datePipe.transform(
          this.emrservice.visitDate,
          "dd/MM/yyyy"
        ),
        LINE1: this.dashboardService.branchmansterObj.line1,
        LINE2: this.dashboardService.branchmansterObj.line2,
        LINE3: this.dashboardService.branchmansterObj.line3,
        LINE4: this.dashboardService.branchmansterObj.line4,
        HOSPITALIMAGE: "../../../" + this.authService.loginclientlogo,
        COMPANYIMAGE: "../../../" + this.authService.leftbottomlogosm,
        CERTIFICATE1IMAGE: "../../../" + this.authService.nabhlogo,
        CERTIFICATE2COMPANYIMAGE: "",
        PrintHeaderArray: type == 'Medical Prescription' ? 'N' : "Y",
        PatientRegistrationArray: "Y",
        VisitMasterArray: type == 'Medical Record' ? "Y" : "N",
        HistoryGeneralArray: type == 'Medical Prescription' ? 'N' : "Y",
        DoctorExaminationMasterArray: "Y",
        AutoRefExaminationArray: type == 'Medical Prescription' ? 'N' : "Y",
        HistoryDiseaseArray: type == 'Medical Prescription' ? 'N' : "Y",
        CounselorExaminationArray: type == 'Medical Record' ? "Y" : "N",
        HistorySurgicalArray: type == 'Medical Prescription' ? 'N' : "Y",
        HistoryFamilyArray: type == 'Medical Prescription' ? 'N' : "Y",
        HistoryDrugAllergyArray: type == 'Medical Prescription' ? 'N' : "Y",
        PresentingComplaintsArray: type == 'Medical Prescription' ? 'N' : "Y",
        AdvisedInvestigationsArray: type == 'Medical Prescription' ? 'N' : "Y",
        IntraocularPressureArray: type == 'Medical Prescription' ? 'N' : "Y",
        OptoExaminationArray: type == 'Medical Prescription' ? 'N' : "Y",
        OptoTestDetailArray: type == 'Medical Prescription' ? 'N' : "Y",
        OptoSlitLampExaminationArray: type == 'Medical Prescription' ? 'N' : "Y",
        CurrentMedicationDetailArray: type == 'Medical Prescription' ? 'N' : "Y",
        DoctorFindingArray: type == 'Medical Prescription' ? 'N' : "Y",
        DoctorInvestigationArray: type == 'Medical Prescription' ? 'N' : "Y",
        DoctorDiagnosisArray: type == 'Medical Prescription' ? 'N' : "Y",
        DoctorPrescriptionArray: "Y",
        DoctorSurgeryArray: type == 'Medical Prescription' ? 'N' : "Y",
        ProcedureRegisterArray: type == 'DailyCaseSheet' || 'Medical Record' ? "Y" : 'N'
      },
    };
    this.ipdService
      .GetWebReportPrint(payload)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            let printContents, popupWin;

            printContents = x[0].printTemplate;
            popupWin = window.open(
              "",
              "_blank",
              "top=0,left=0,height=100%,width=auto"
            );

            popupWin.document.open();
            popupWin.document.write(`
  <html>
   
  <body onload="window.print()">${printContents}
  </body>
  </html>`);

            popupWin.document.close();
          } else {
            this.dashboardService.openSnackBar("Report Template Not Set", "OK");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  getBranchDetail(id) {
    this.dashboardService.branchmansterObj = {};
    this.branchMatserService
      .getBrachMasterItem(id)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (x: any) => {
          this.dashboardService.branchmansterObj = x[0];
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  signaturefileName: string = "";
  refreshdoc_list() {
    this.emrservice
      .getImagedata(
        this.authService.Loggeduser.userid,
        this.authService.Loggeduser.branchid,
        "DoctorSignature"
      )
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data: any) => {
          if (data != null && data != undefined) {
            let checknull = data.filter((item) => item != null);
            this.signaturefileName = checknull[0];
          } else {
            this.signaturefileName = "";
          }
        },
        (err) => { }
      );
  }

  Optodata: OptoModel = {};
  printTimeline() {
    this.Optodata = {};
    this.dashboardService
      .get_opto_data(this.emrservice.visitid)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((data) => {
        this.Optodata = data;
        let advisedId = this.Optodata.fkGpadvicedById;
        if (advisedId != 0 && advisedId != null) {
          let getAdvisedid = this.authService.users.filter(
            (item) => item.pkUserId == advisedId
          )[0];

          var advisedName = getAdvisedid.userName;
        }

        this.Optodata.visitDate = this.datePipe.transform(
          this.emrservice.visitDate,
          "dd-MM-yyyy"
        );
        let payload = {
          WebReportPrintMaster: {
            module: "Primary Exam",
            printOption: "Glass Prescription",
            printType: "WebNetramReport",
            PATIENTNAME:
              this.opdvisitService.patientdetails.firstName +
              " " +
              this.opdvisitService.patientdetails.lastName,
            MRDNO: this.opdvisitService.patientdetails.pkRegId,
            MobileNo: this.opdvisitService.patientdetails.mobileNo,
            PatientAddress: this.opdvisitService.patientdetails.paddress,
            PRINTDATE: this.datePipe.transform(
              this.authService.localDate,
              "dd-MM-yyyy"
            ),
            PrintTime: this.convert24Time12Hour(new Date()),
            PatientAge: this.opdvisitService.patientdetails.ageYear,
            PatientGender: this.opdvisitService.patientdetails.sex,
            PatientAgeAndGender:
              this.opdvisitService.patientdetails.ageYear +
              "|" +
              this.opdvisitService.patientdetails.sex,
            BILLINGCOMPANYNAME: this.authService.Loggeduser.billingcompanyname,
            LINE1: this.dashboardService.branchmansterObj.line1,
            LINE2: this.dashboardService.branchmansterObj.line2,
            LINE3: this.dashboardService.branchmansterObj.line3,
            LINE4: this.dashboardService.branchmansterObj.line4,
            HOSPITALIMAGE: "../../../" + this.authService.loginclientlogo,
            COMPANYIMAGE: "../../../" + this.authService.leftbottomlogosm,
            CERTIFICATE1IMAGE: "../../../" + this.authService.nabhlogo,
            CERTIFICATE2COMPANYIMAGE:
              this.signaturefileName != ""
                ? this.opdvisitService.mainUrl +
                "DoctorSignature/" +
                this.signaturefileName +
                "?" +
                Math.floor(Math.random() * 100) +
                1
                : "",
            GpAdvisedBy: advisedName,
            ...this.Optodata,
          },
        };

        this.ipdService
          .GetWebReportPrint(payload)
          .pipe(takeUntil(this.destroydashboard$))
          .subscribe(
            (x: any) => {
              if (x.length > 0) {
                let printContents, popupWin;

                printContents = x[0].printTemplate;
                popupWin = window.open(
                  "",
                  "_blank",
                  "top=0,left=0,height=100%,width=auto"
                );

                popupWin.document.open();
                popupWin.document.write(`
      <html>
       
    <body onload="window.print()">${printContents}
    </body>
      </html>`);

                popupWin.document.close();
              } else {
                this.dashboardService.openSnackBar(
                  "Report Template Not Set",
                  "OK"
                );
              }
            },
            (err) => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar(
                  "You Don't have Permission",
                  "OK"
                );
              } else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar(
            "You Don't have Permission",
            "OK"
          );
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  timecheck: any;
  convert24Time12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != "") {
      let hour = this.timecheck.split(":")[0];
      let min = this.timecheck.split(":")[1];
      let part = hour > 12 ? "PM" : "AM";

      min = (min + "").length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + "").length == 1 ? `0${hour}` : hour;

      return `${hour}:${min} ${part}`;
    } else {
      return null;
    }
  }
  getsummary_urll(patientid: number, type: number) {
    if (patientid) {
      if (this.opdvisitService.visitdates.length > 0 || type == 0) {
        if (type == 1) {
          let checkreporttype = this.authService.webreportConfig.filter(
            (item) =>
              item.printOption == "Glass Prescription" &&
              item.printType == "NetramReport"
          );
          if (checkreporttype.length > 0) {
            this.dashboardService
              .getsummary_url()
              .pipe(takeUntil(this.destroydashboard$))
              .subscribe(
                (data) => this.succesurll(data, patientid, type),
                (err) => this.failedurl(err)
              );
          } else {
            this.printTimeline();
          }
        } else {
          let checkreporttype = this.authService.webreportConfig.filter(
            (item) =>
              item.printOption == "Medical Record" &&
              item.printType == "NetramReport"
          );
          if (checkreporttype.length > 0) {
            this.dashboardService
              .getsummary_url()
              .pipe(takeUntil(this.destroydashboard$))
              .subscribe(
                (data) => this.succesurll(data, patientid, type),
                (err) => this.failedurl(err)
              );
          } else {
            this.printTimelineBill('Medical Record', patientid);
          }
        }
      } else {
        this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg27"],
          this.authService.validationMsg["Ok"]
        );
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg28"],
        this.authService.validationMsg["Ok"]
      );
    }
  }

  succesurll(data, patientid, type) {
    const urldate = data.filter((item) => item.propertyName == "WebURL");
    const pageheader = data.filter(
      (item) => item.propertyName == "PageHeadWebReport"
    );
    const checktrue = pageheader[0]?.propertyValue;
    const url = urldate[0].propertyValue;
    const prourl = data.filter(
      (item) => item.propertyName == "WebGlassPrescriptionPageName"
    );
    var pageNameurl: string = '';
    if (prourl.length > 0) {
      pageNameurl = prourl[0]?.propertyValue ? prourl[0]?.propertyValue : 'GlassPrescription.aspx';
    } else {
      pageNameurl = 'GlassPrescription.aspx';
    }
    if (type == 0) {
      window.open(
        url +
        "PatientEMRSummary.aspx?RegID=" +
        patientid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&VisitOrderType=DESC" +
        "&BranchId=" +
        this.authService.Loggeduser.branchid
      );
    } else if (type == 1) {
      window.open(
        url + pageNameurl +
        "?RegID=" +
        patientid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&VisitId=" +
        this.emrservice.visitid +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&PageHeadWebReport=Y" +
        "&VisitDate=" +
        this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd")
      );
    } else if (type == 2) {
      window.open(
        url +
        "TodayEMRVisitDayCaseSheet.aspx?VisitId=" +
        this.emrservice.visitid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&VisitOrderType=ASC" +
        "&BranchId=" +
        this.authService.Loggeduser.branchid +
        "&PageHeadWebReport=Y" +
        "&VisitDate=" +
        this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd")
      );
    }
  }
  // events
  public chartClicked({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void { }

  public chartHovered({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void { }

  //corporate template detail
  OpenMediniceTemplate(regid, visitid) {

    const dialogRef = this.dialog.open(CounselorComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "90%",
      disableClose: true,
      width: "90%",
      data: {
        Patientid: regid,
        visitid: visitid,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        this.emrservice.visitid = null;
      });
  }
  ClearCallCenter(type) {
    this.norecordfound = false;
    this.userSearchData = [];
    this.visistlistArray = [];
    this.preAppointmentArray = [];
    this.currentAppointmentArray = [];
    this.freshAppointmentArray = [];
    this.SurgeryDetailArray = [];
    this.getdoneinvesArray = [];
    this.getdonesurgeryArray = [];
    this.examinationDetailArray.visitDate = null;
    this.examinationDetailArray.drName = null;
    this.examinationDetailArray.drRemarks = null;
    this.examinationDetailArray.nextVisitPlan = null;
    this.examinationDetailArray.nextReview = null;
    this.examinationDetailArray.nextReviewUnit = null;
    this.examinationDetailArray.nextReviewDate = null;
    this.examinationDetailArray.nextReviewNote = null;
    if (type == 0) {
      this.speachtotextservice.callCentertext = "";
      this.selectSearchType = "MobileNo";
      this.fk_patientId = null;
    }
  }
  regindex: any;
  dataSearchbyid(regid, mobileno, i) {
    this.regindex = i;
    this.selectSearchType == "RegId";
    // this.speachtotextservice.callCentertext=regid;

    this.fk_patientId = regid;
    this.visistlistArray = [];
    this.preAppointmentArray = [];
    this.currentAppointmentArray = [];
    this.freshAppointmentArray = [];
    this.SurgeryDetailArray = [];
    this.getdoneinvesArray = [];
    this.getdonesurgeryArray = [];
    this.examinationDetailArray.visitDate = null;
    this.examinationDetailArray.drName = null;
    this.examinationDetailArray.drRemarks = null;
    this.examinationDetailArray.nextVisitPlan = null;
    this.examinationDetailArray.nextReview = null;
    this.examinationDetailArray.nextReviewUnit = null;
    this.examinationDetailArray.nextReviewDate = null;
    this.examinationDetailArray.nextReviewNote = null;
    this.getFreshAppoitment("MobileNo", mobileno);
    this.getVIsitlistdata(regid, 0);
    this.getBookedsurgeryRegIddata(regid);
    this.getpreveiousAppointment(regid);
    this.GetDoneSurgeryByRegIddata(regid);
    this.GetProcedureRegisterByRegId(regid);
  }
  userSearchData: any = [];
  fk_patientId: any = null;
  norecordfound: boolean = false;
  GetPatientBySearchTypeBy() {
    this.showspinner = true;
    this.norecordfound = false;
    if (this.speachtotextservice.callCentertext) {
      if (this.selectSearchType == "MobileNo") {
        var searchtype = "M";
      } else if (this.selectSearchType == "RegId") {
        var searchtype = "REGID";
      } else {
        var searchtype = "D";
      }

      this.dashboardService
        .GetPatientBySearchTypeByValueOrderBy(
          searchtype,
          this.speachtotextservice.callCentertext,
          "ASC"
        )
        .pipe(takeUntil(this.destroydashboard$))
        .subscribe(
          (item) => {
            this.showspinner = false;
            this.ClearCallCenter(1);
            this.userSearchData = item;
            if (this.selectSearchType == "MobileNo") {
              this.getFreshAppoitment(
                this.selectSearchType,
                this.speachtotextservice.callCentertext
              );
            }
            if (this.userSearchData.length > 0) {
              this.regindex = 0;
              this.fk_patientId = this.userSearchData[0].pk_RegId;
              this.getVIsitlistdata(this.userSearchData[0].pk_RegId, 0);
              this.getBookedsurgeryRegIddata(this.userSearchData[0].pk_RegId);
              this.getpreveiousAppointment(this.userSearchData[0].pk_RegId);
              this.GetDoneSurgeryByRegIddata(this.userSearchData[0].pk_RegId);
              this.GetProcedureRegisterByRegId(this.userSearchData[0].pk_RegId);
            } else {
              this.norecordfound = true;
            }
          },
          (err) => {
            this.showspinner = false;
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        );
    }
  }
  AppointmentColor(status, isblock) {
    if (status == true) {
      return this.appointmentColorobj.cancelledAppointment;
    } else if (isblock == true) {
      return this.appointmentColorobj.blockedAppointment;
    } else {
      return "";
    }
  }
  getcolor(data, data1, IsCancel, ConfirmMe) {
    if (
      data != null ||
      data1 != null ||
      IsCancel != null ||
      ConfirmMe != null
    ) {
      if (IsCancel == true) {
        return this.appointmentColorobj.cancelledAppointment;
      } else {
        if (ConfirmMe == true) {
          return this.appointmentColorobj.reportedAppointment;
        } else if (data1 == true) {
          return this.appointmentColorobj.blockedAppointment;
        } else if (data != null) {
          return "#b7c3d9";
        } else if (data == null && data1 == false) {
          return this.appointmentColorobj.bookedAppointment;
        }
      }
    } else {
      return this.appointmentColorobj.bookedAppointment;
    }
  }
  private preAppointmentArray: any = [];
  private currentAppointmentArray: any = [];
  getpreveiousAppointment(regid) {
    this.dashboardService
      .GetPatientBySearchAppointmentOrderBy("PATIENTID", regid, "ASC")
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item) => {
          this.preAppointmentArray = [];
          this.currentAppointmentArray = [];
          if (item.length > 0) {
            this.preAppointmentArray = item.filter(
              (x) =>
                this.datePipe.transform(
                  this.authService.localDate,
                  "yyyy-MM-dd"
                ) > this.datePipe.transform(x.apptDate, "yyyy-MM-dd")
            );
            this.currentAppointmentArray = item.filter(
              (x) =>
                this.datePipe.transform(x.apptDate, "yyyy-MM-dd") >=
                this.datePipe.transform(
                  this.authService.localDate,
                  "yyyy-MM-dd"
                )
            );
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  private freshAppointmentArray: any = [];
  getFreshAppoitment(searchtype, serachvalue) {
    this.dashboardService
      .GetPatientBySearchAppointmentOrderBy(searchtype, serachvalue, "ASC")
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item) => {
          this.freshAppointmentArray = [];
          // this.preAppointmentArray = [];
          // this.currentAppointmentArray =[];
          if (item.length > 0) {
            this.freshAppointmentArray = item;
            // this.preAppointmentArray = item.filter(x=> (this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd") > this.datePipe.transform(x.apptDate, "yyyy-MM-dd")) && x.fk_RegId >0);
            // this.currentAppointmentArray = item.filter(x=>(this.datePipe.transform(x.apptDate, "yyyy-MM-dd") >=this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd") ) && x.fk_RegId >0);
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  visitlistcolor: any;

  private visistlistArray: any = [];
  getVIsitlistdata(patientid, index) {
    this.dashboardService
      .getVisitdata(patientid, 0, 0)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (data) => {
          this.visistlistArray = [];

          if (data.length > 0) {
            this.visistlistArray = data.filter(
              (item) => item.pK_ExamId != null
            );
            if (this.visistlistArray.length > 0) {
              this.visitlistcolor = index;
              this.getSurgeryDetailByRegIddata(
                this.visistlistArray[0].fK_RegId,
                this.visistlistArray[0].fK_VisitId,
                this.visistlistArray[0].doctorId
              );
              this.getexaminationDetaildata(
                this.visistlistArray[0].fK_RegId,
                this.visistlistArray[0].fK_VisitId,
                this.visistlistArray[0].doctorId
              );
            }
          } else {
            this.SurgeryDetailArray = [];
            this.examinationDetailArray.visitDate = null;
            this.examinationDetailArray.drName = null;
            this.examinationDetailArray.drRemarks = null;
            this.examinationDetailArray.nextVisitPlan = null;
            this.examinationDetailArray.nextReview = null;
            this.examinationDetailArray.nextReviewUnit = null;
            this.examinationDetailArray.nextReviewDate = null;
            this.examinationDetailArray.nextReviewNote = null;
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  getdatabyvisitid(patientid, visitid, docid, index) {
    this.visitlistcolor = index;
    this.getSurgeryDetailByRegIddata(patientid, visitid, docid);
    this.getexaminationDetaildata(patientid, visitid, docid);
  }
  SurgeryDetailArray: any = [];
  getSurgeryDetailByRegIddata(regid, visitid, doctorid) {
    this.emrservice
      .GetSurgeryDetailByRegId(regid, visitid, doctorid)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item) => {
          this.SurgeryDetailArray = [];
          this.SurgeryDetailArray = item;
          console.log(this.SurgeryDetailArray);
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  examinationDetailArray: any = {};
  getexaminationDetaildata(regid, visitid, doctorid) {
    this.emrservice
      .GetFindingGResultByregid(regid, visitid, doctorid)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item: any) => {
          this.examinationDetailArray = {};
          if (item.length > 0) {
            this.examinationDetailArray = item[0];
          } else {
            this.examinationDetailArray.visitDate = null;
            this.examinationDetailArray.drName = null;
            this.examinationDetailArray.drRemarks = null;
            this.examinationDetailArray.nextVisitPlan = null;
            this.examinationDetailArray.nextReview = null;
            this.examinationDetailArray.nextReviewUnit = null;
            this.examinationDetailArray.nextReviewDate = null;
            this.examinationDetailArray.nextReviewNote = null;
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  private getdonesurgeryArray: any = [];
  GetDoneSurgeryByRegIddata(regid) {
    this.dashboardService
      .GetDoneSurgeryByRegId(regid)
      .pipe(takeUntil(this.destroydashboard$))
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (x: any) => {
          this.getdonesurgeryArray = [];
          this.getdonesurgeryArray = x;
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  private getdoneinvesArray: any = [];
  GetProcedureRegisterByRegId(regid) {
    this.dashboardService
      .GetProcedureRegisterByRegId(regid)
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (x: any) => {
          this.getdoneinvesArray = [];
          this.getdoneinvesArray = x;
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  private bookedSurgeryDetailArray: any = [];
  getBookedsurgeryRegIddata(regid) {
    this.dashboardService
      .GetBookingSurgerylistOrderByid(
        regid,
        this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd")
      )
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item) => {
          this.bookedSurgeryDetailArray = [];
          this.bookedSurgeryDetailArray = item;
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      );
  }
  startService() {
    this.speachtotextservice.callCentertext = "";
    this.speachtotextservice.start("CallCenter");
  }
  stopService() {
    this.speachtotextservice.stop("CallCenter");
    if (this.speachtotextservice.callCentertext) {
      this.GetPatientBySearchTypeBy();
    }
  }
  openAppointmentModel() {
    const dialogRef = this.dialog.open(UpgradeComponent, {
      disableClose: true,
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      width: "100%",
      data: {
        isopenpopup: true,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe((result) => {
        this.opdvisitService.checkshort = false;
      });
  }

  appointmentColorobj: AppointmentColorModel = {};
  getopdvistColor() {
    this.dashboardService
      .AppointmentCol()
      .pipe(takeUntil(this.destroydashboard$))
      .subscribe(
        (item: any) => {
          if (item.length > 0) {
            const blockdata = item.filter(
              (x) => x.propertyName.toLowerCase() == "total"
            );
            const bookeddata = item.filter(
              (x) => x.propertyName.toLowerCase() == "booked"
            );
            const reporteddata = item.filter(
              (x) => x.propertyName.toLowerCase() == "reported"
            );
            const blockeddata = item.filter(
              (x) => x.propertyName.toLowerCase() == "blocked"
            );
            const cancelledata = item.filter(
              (x) => x.propertyName.toLowerCase() == "cancelled"
            );
            const completeslotdata = item.filter(
              (x) => x.propertyName.toLowerCase() == "completeslot"
            );
            if (blockdata.length > 0) {
              this.appointmentColorobj.totalAppointment =
                blockdata[0].propertyValue;
            } else {
              this.appointmentColorobj.totalAppointment = "#16c6f1";
            }
            if (bookeddata.length > 0) {
              this.appointmentColorobj.bookedAppointment =
                bookeddata[0].propertyValue;
            } else {
              this.appointmentColorobj.bookedAppointment = "#ebebeb";
            }
            if (reporteddata.length > 0) {
              this.appointmentColorobj.reportedAppointment =
                reporteddata[0].propertyValue;
            } else {
              this.appointmentColorobj.reportedAppointment = "#CAF6B8";
            }
            if (blockeddata.length > 0) {
              this.appointmentColorobj.blockedAppointment =
                blockeddata[0].propertyValue;
            } else {
              this.appointmentColorobj.blockedAppointment = "#998b8b";
            }
            if (cancelledata.length > 0) {
              this.appointmentColorobj.cancelledAppointment =
                cancelledata[0].propertyValue;
            } else {
              this.appointmentColorobj.cancelledAppointment = "#FFFF00";
            }
            if (completeslotdata.length > 0) {
              this.appointmentColorobj.completeslotAppointment =
                completeslotdata[0].propertyValue;
            } else {
              this.appointmentColorobj.completeslotAppointment = "#0D24EE";
            }
          } else {
            this.appointmentColorobj.blockedAppointment = "#998b8b";
            this.appointmentColorobj.cancelledAppointment = "#FFFF00";
            this.appointmentColorobj.totalAppointment = "#16c6f1";
            this.appointmentColorobj.reportedAppointment = "#CAF6B8";
            this.appointmentColorobj.completeslotAppointment = "#0D24EE";
            this.appointmentColorobj.bookedAppointment = "#ebebeb";
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API Failed", "ok");
        }
      );
  }

  ChangeCallStatus(pid: any, roomName: any, loginroomId: any, type: any) {

    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
    var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
    var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
    if (queueproty[0]?.propertyValue == 'Y' && queueurl[0]?.propertyValue != null && queueurl[0]?.propertyValue != undefined && queuetoken[0]?.propertyValue != null && queuetoken[0]?.propertyValue != undefined) {
      const headers = new HttpHeaders().set('X-API-KEY', `${queuetoken[0]?.propertyValue}`);
      this.http.get<any>(queueurl[0]?.propertyValue + "Interface/GetVisitcalldetails/" + pid + '/' + this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd") + '/' + this.authService.Loggeduser.branchid, { headers }).pipe(takeUntil(this.destroydashboard$)).subscribe((resp) => {
        if (type == 'CALL' && resp.isCall == 'Y') {
          return this.dashboardService.openSnackBar("Patient Already Called", "OK");
        } else if (type == 'DisConnect' && resp.isCall == 'N') {
          this.dashboardService.openSnackBar("Patient Already Aborted", "OK");
        } else {
          if (resp.fK_VisitId > 0) {
            let queuevisitObj = {
              "PK_VisitId": resp.pK_VisitId,
              "FK_RegID": pid,
              "fk_visitid": resp.fK_VisitId,
              "Remarks": type,
              "RoomName": roomName,
              "Fk_CreatedById": this.authService.Loggeduser.userid,
              "Fk_RoomId": loginroomId ? loginroomId : this.authService.Loggeduser.roomid,
              "fk_branchid": this.authService.Loggeduser.branchid,
            }
            this.http.post<any>(queueurl[0]?.propertyValue + "Interface/UpdatePatientCallStatus", queuevisitObj, { headers }).pipe(takeUntil(this.destroydashboard$)).subscribe((resp) => {

              if (type == 'DisConnect') {
                this.dashboardService.openSnackBar("Call aborted successfully", "OK");
              } else if (type == 'CALL') {
                this.closeCallPatientModel();
                this.getpatientdetails(pid, "emr");

                this.dashboardService.openSnackBar("Patient called successfully", "OK");
              }

            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            })
          }

        }
      })

    }
  }

  AIRecordModal() {
    const dialogRef = this.dialog.open(AIPrescriptionComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '90vw',
      maxHeight: '90vw',
      disableClose: true,
      width: '90%',
      height: '90%',
      data: {
        parametertype: 'OPDMPresRemarks'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroydashboard$)).subscribe(result => {

    });
  }



  sortColumnField = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  private FIELD_MAP: Record<string, string> = {
    sequence: 'sequence',
    FK_RegID: 'fK_RegID',
    PatientName: 'patientName',
    OLDMRDNO: 'oldmrdno',
    AgeSexDesc: 'ageYear',
    ApptTime: 'apptTime',
    VisitTime: 'visitTime',
    CategoryName: 'categoryName',
    AR: 'ar',
    OptName: 'op',
    Doctor: 'dr',
    Physician: 'phy',
    CONS: 'cons',
    ProN: 'pro',
    ClinicalDept: 'clinicalDept',
    DilationTime: 'dilationTime',
    ISPD: 'ispd',
    TotalTime: 'totalTime',
    Party: 'party',
    MoveTo: 'moveTo',
    Remarks: 'remarks',
    ReferredBy: 'referredByName'
  };

  setSort(fieldName: string) {
    if (this.sortColumnField === fieldName) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnField = fieldName;
      this.sortDirection = 'asc';
    }
    this.applySort();
  }

  applySort() {
    if (this.sortColumnField === 'TotalTime') {
      const toMinutes = (timeStr: string) => {
        if (!timeStr) return 0;
        const [h, m] = timeStr.split(':').map(s => parseInt(s, 10) || 0);
        return h * 60 + m;
      };

      this.dataSource.data = [...this.dataSource.data].sort((a, b) => {
        const strA = this.getTotaltime(a.visitTime, a.fK_PatientLocationId, a.returnTime);
        const strB = this.getTotaltime(b.visitTime, b.fK_PatientLocationId, b.returnTime);

        const av = toMinutes(strA);
        const bv = toMinutes(strB);

        if (av < bv) return this.sortDirection === 'asc' ? -1 : 1;
        if (av > bv) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
      return;
    }

    const prop = this.FIELD_MAP[this.sortColumnField] || this.sortColumnField;

    const normalize = (row: any) => {
      let v = row[prop];
      if (prop === 'patientName' && typeof v === 'string') {
        const parts = v.split('.');
        v = (parts.length > 1 ? parts[1] : parts[0]).trim();
      }
      if (prop === 'categoryName' && typeof v === 'string') {
        v = v.toLowerCase();
      }
      return v;
    };

    this.dataSource.data = [...this.dataSource.data].sort((a, b) => {
      const av = normalize(a);
      const bv = normalize(b);

      if (av == null || av === '') return 1;
      if (bv == null || bv === '') return -1;

      if (av < bv) return this.sortDirection === 'asc' ? -1 : 1;
      if (av > bv) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  sortData(sort: Sort) {

    this.sortColumnField = sort.active;
    this.sortDirection = sort.direction as 'asc' | 'desc';
    if (this.sortDirection === 'desc') {
      const prop = this.FIELD_MAP[this.sortColumnField] || this.sortColumnField;

      const nonEmptyCount = this.dataSource.data
        .filter(row => {
          const v = row[prop];
          return v != null && String(v).trim() !== '';
        })
        .length;

      if (nonEmptyCount === 1) {
        this.filterby_todays_date(1);
        return
      }
    }

    this.applySort();

  }


  selectedFile: any;
  previewUrl: any = '';
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];

    const reader = new FileReader();
    reader.onload = () => this.previewUrl = reader.result;
    reader.readAsDataURL(this.selectedFile);
  }
  analyzeImage() {
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    // this.http.post<any>('http://localhost:5000/analyze', formData)
    //   .subscribe(
    //     response => this.result = response.diagnosis,
    //     error => this.result = 'Error analyzing image.'
    //   );
  }

}



